"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var icons = [{
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M16.759 16H1a.5.5 0 0 1 0-1h15.759C20.434 15 23 12.738 23 9.5S20.434 4 16.759 4H12a.5.5 0 0 1 0-1h4.759C21.022 3 24 5.673 24 9.5S21.022 16 16.759 16z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M5.5 21a.502.502 0 0 1-.354-.146l-5-5a.5.5 0 0 1 0-.707l5-5a.5.5 0 0 1 .707.707L1.207 15.5l4.646 4.646A.5.5 0 0 1 5.5 21z"
    }
  }],
  title: "ab"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M11.5 24.5a.5.5 0 0 1-.5-.5V1a.5.5 0 0 1 1 0v23a.5.5 0 0 1-.5.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M23 13H0a.5.5 0 0 1 0-1h23a.5.5 0 0 1 0 1z"
    }
  }],
  title: "add"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M23 23H1a.5.5 0 0 1 0-1h22a.5.5 0 0 1 0 1zM21 2H2a.5.5 0 0 1 0-1h19a.5.5 0 0 1 0 1zm-3 3H6a.5.5 0 0 1 0-1h12a.5.5 0 0 1 0 1zm2 3H3a.5.5 0 0 1 0-1h17a.5.5 0 0 1 0 1zm3 3H1a.5.5 0 0 1 0-1h22a.5.5 0 0 1 0 1zm-4 3H4a.5.5 0 0 1 0-1h15a.5.5 0 0 1 0 1zm-2 3H7a.5.5 0 0 1 0-1h10a.5.5 0 0 1 0 1zm2 3H4a.5.5 0 0 1 0-1h15a.5.5 0 0 1 0 1z"
    }
  }],
  title: "align-center"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M17.5 23H.5a.5.5 0 0 1 0-1h17a.5.5 0 0 1 0 1zm6-21H.5a.5.5 0 0 1 0-1h23a.5.5 0 0 1 0 1zm0 3H.5a.5.5 0 0 1 0-1h23a.5.5 0 0 1 0 1zm0 3H.5a.5.5 0 0 1 0-1h23a.5.5 0 0 1 0 1zm0 3H.5a.5.5 0 0 1 0-1h23a.5.5 0 0 1 0 1zm0 3H.5a.5.5 0 0 1 0-1h23a.5.5 0 0 1 0 1zm0 3H.5a.5.5 0 0 1 0-1h23a.5.5 0 0 1 0 1zm0 3H.5a.5.5 0 0 1 0-1h23a.5.5 0 0 1 0 1z"
    }
  }],
  title: "align-justify"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M23.5 23H.5a.5.5 0 0 1 0-1h23a.5.5 0 0 1 0 1zm-3-21H.5a.5.5 0 0 1 0-1h20a.5.5 0 0 1 0 1zm-4 3H.5a.5.5 0 0 1 0-1h16a.5.5 0 0 1 0 1zm2 3H.5a.5.5 0 0 1 0-1h18a.5.5 0 0 1 0 1zm5 3H.5a.5.5 0 0 1 0-1h23a.5.5 0 0 1 0 1zm-4 3H.5a.5.5 0 0 1 0-1h19a.5.5 0 0 1 0 1zm-3 3H.5a.5.5 0 0 1 0-1h16a.5.5 0 0 1 0 1zm3 3H.5a.5.5 0 0 1 0-1h19a.5.5 0 0 1 0 1z"
    }
  }],
  title: "align-left"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M23.5 23H.5a.5.5 0 0 1 0-1h23a.5.5 0 0 1 0 1zm0-21h-19a.5.5 0 0 1 0-1h19a.5.5 0 0 1 0 1zm0 3h-16a.5.5 0 0 1 0-1h16a.5.5 0 0 1 0 1zm0 3h-19a.5.5 0 0 1 0-1h19a.5.5 0 0 1 0 1zm0 3H.5a.5.5 0 0 1 0-1h23a.5.5 0 0 1 0 1zm0 3h-19a.5.5 0 0 1 0-1h19a.5.5 0 0 1 0 1zm0 3h-16a.5.5 0 0 1 0-1h16a.5.5 0 0 1 0 1zm0 3h-19a.5.5 0 0 1 0-1h19a.5.5 0 0 1 0 1z"
    }
  }],
  title: "align-right"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M23.5 9H.5a.5.5 0 0 1-.5-.5v-5A.5.5 0 0 1 .5 3h23a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5zM1 8h22V4H1v4z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M22.5 22h-21a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5h21a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5zM2 21h20V9H2v12z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M15.5 14h-7a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5zM9 13h6v-1H9v1z"
    }
  }],
  title: "archive"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M18 24a.5.5 0 0 1-.361-.154l-11-11.468a.5.5 0 0 1-.002-.69L17.577.156c.19-.2.507-.208.707-.019s.208.506.019.707L7.691 12.03l10.67 11.124A.5.5 0 0 1 18 24z"
    }
  }],
  title: "arrow-left"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M6.5 24a.5.5 0 0 1-.361-.846l10.67-11.124L6.198.844a.5.5 0 1 1 .726-.688l10.939 11.532a.498.498 0 0 1-.001.69l-11 11.468A.505.505 0 0 1 6.5 24z"
    }
  }],
  title: "arrow-right"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M22 12H0a.5.5 0 0 1 0-1h22a.5.5 0 0 1 0 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M15.575 18.946a.498.498 0 0 1-.329-.876l7.57-6.624-7.57-6.624a.499.499 0 1 1 .659-.752l8 7a.497.497 0 0 1 0 .752l-8 7a.503.503 0 0 1-.33.124z"
    }
  }],
  title: "arrow-right-stem"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M12.173 21.9c-4.373 0-6.812-.191-7.292-.381-.846-.335-.33-2.724-.323-2.748.122-.42.596-.582 2.219-1.078.764-.233 2.042-.623 2.26-.834.266-.263.538-1.562.627-2.612a.5.5 0 0 1 .996.084c-.05.596-.264 2.591-.92 3.24-.36.356-1.249.646-2.671 1.08-.559.17-1.3.397-1.579.532-.062.359-.106 1.096-.067 1.444.581.097 2.501.274 6.751.274 4.971 0 6.354-.164 6.737-.251.059-.341.048-1.13-.007-1.448-.282-.129-1.044-.357-1.618-.529-1.546-.462-2.51-.769-2.87-1.129-.636-.641-.724-2.667-.735-3.273a.5.5 0 0 1 .49-.51c.262 0 .504.214.51.49.022 1.163.23 2.372.444 2.587.231.215 1.618.629 2.447.877 1.551.464 1.966.61 2.158.876.271.372.337 2.382-.079 2.793-.222.218-.524.516-7.478.516z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M12.173 15.624c-1.7 0-3.393-1.532-4.527-4.099-.34-.769-.543-2.465-.543-4.538 0-3.073 2.274-5.573 5.07-5.573 2.843 0 5.069 2.409 5.069 5.485 0 2.157-.204 3.885-.547 4.623-1.207 2.607-2.855 4.102-4.522 4.102zm0-13.21c-2.244 0-4.07 2.052-4.07 4.573 0 2.288.246 3.657.457 4.134 1.143 2.583 2.616 3.503 3.613 3.503 1.242 0 2.594-1.317 3.615-3.522.227-.487.454-1.976.454-4.203 0-2.515-1.787-4.485-4.069-4.485zM3.478 18.789c-.747 0-2.536-.221-2.916-.27a.559.559 0 0 1-.114-.028c-.773-.292-.328-2.215-.322-2.234.115-.379.476-.498 1.836-.893.587-.17 1.569-.456 1.757-.61.163-.155.382-1.057.455-1.889a.501.501 0 0 1 .996.088c-.041.462-.217 2.012-.77 2.532-.303.286-1.018.507-2.159.839-.408.119-.943.274-1.188.375a5.618 5.618 0 0 0-.051.868c.936.113 2.243.25 2.574.22a.51.51 0 0 1 .542.454.5.5 0 0 1-.454.542 2.471 2.471 0 0 1-.186.006z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M6.268 14.039c-1.388 0-2.765-1.183-3.685-3.164-.277-.596-.443-1.9-.443-3.488 0-2.391 1.852-4.335 4.128-4.335a.5.5 0 0 1 0 1c-1.725 0-3.128 1.496-3.128 3.335 0 1.599.176 2.693.35 3.067.886 1.906 2.016 2.585 2.778 2.585a.5.5 0 0 1 0 1zm14.969 4.75c-.065 0-.124-.002-.176-.007a.5.5 0 1 1 .088-.996c.307.025 1.196-.097 1.849-.205a5.492 5.492 0 0 0-.05-.883c-.245-.101-.78-.256-1.188-.375-1.142-.332-1.856-.554-2.159-.839-.553-.521-.729-2.07-.77-2.533a.5.5 0 0 1 .454-.542.506.506 0 0 1 .542.454c.074.833.293 1.735.459 1.893.184.15 1.166.436 1.753.606 1.36.396 1.721.514 1.836.893.006.019.451 1.942-.322 2.234-.353.073-1.646.3-2.316.3z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M17.732 14.039a.5.5 0 0 1 0-1c.763 0 1.893-.679 2.778-2.584.174-.375.35-1.469.35-3.068 0-1.839-1.403-3.335-3.128-3.335a.5.5 0 0 1 0-1c2.276 0 4.128 1.945 4.128 4.335 0 1.588-.166 2.892-.443 3.489-.92 1.98-2.297 3.163-3.685 3.163z"
    }
  }],
  title: "audiences"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M11.479 23.925c-4.657 0-8.445-3.788-8.445-8.445s3.788-8.445 8.445-8.445 8.445 3.788 8.445 8.445-3.787 8.445-8.445 8.445zm0-15.891c-4.105 0-7.445 3.34-7.445 7.445s3.34 7.445 7.445 7.445 7.445-3.34 7.445-7.445-3.339-7.445-7.445-7.445z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M14.515 20.227a.497.497 0 0 1-.26-.073l-2.784-1.696-2.782 1.664a.502.502 0 0 1-.735-.574l.911-2.989-2.249-1.655A.5.5 0 0 1 6.911 14h2.737l1.381-2.658c.172-.332.715-.332.887 0L13.298 14h2.737a.502.502 0 0 1 .296.904l-2.249 1.649.911 3.029a.5.5 0 0 1-.478.645zm-3.042-2.854c.09 0 .181.024.26.073l1.927 1.174-.637-2.117a.499.499 0 0 1 .183-.548L14.508 15h-1.514a.498.498 0 0 1-.443-.27l-1.078-2.073-1.077 2.073a.5.5 0 0 1-.444.27H8.435l1.307.962a.5.5 0 0 1 .183.548l-.636 2.088 1.928-1.153a.48.48 0 0 1 .256-.072zM6 7.5a.499.499 0 0 1-.463-.312L4.037 3.5A.5.5 0 0 1 4 3.312V.5a.5.5 0 0 1 .5-.5H10a.5.5 0 0 1 0 1H5v2.215l1.463 3.597A.5.5 0 0 1 6 7.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M17 7.5a.498.498 0 0 1-.462-.688L18 3.215V1h-8a.5.5 0 0 1 0-1h8.5a.5.5 0 0 1 .5.5v2.812a.504.504 0 0 1-.037.188l-1.5 3.688A.499.499 0 0 1 17 7.5zm-8.5-1A.5.5 0 0 1 8 6V1a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.5.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M12.5 6.5A.5.5 0 0 1 12 6V1a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.5.5zm-2 0A.5.5 0 0 1 10 6V1a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.5.5zm4 0A.5.5 0 0 1 14 6V1a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.5.5z"
    }
  }],
  title: "badge"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-23C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M5.659 16.808l-.047-.002a.501.501 0 0 1-.366-.217A8.11 8.11 0 0 1 3.833 12c0-4.503 3.664-8.166 8.167-8.166 1.646 0 3.232.488 4.59 1.412a.497.497 0 0 1 .072.766L6.013 16.661a.498.498 0 0 1-.354.147zM12 4.834c-3.952 0-7.167 3.215-7.167 7.166 0 1.24.315 2.441.918 3.509l9.759-9.758A7.134 7.134 0 0 0 12 4.834zm0 15.332a8.124 8.124 0 0 1-4.59-1.412.497.497 0 0 1-.072-.766l10.649-10.65a.521.521 0 0 1 .4-.145.504.504 0 0 1 .366.217A8.12 8.12 0 0 1 20.166 12c.001 4.503-3.663 8.166-8.166 8.166zm-3.51-1.917a7.132 7.132 0 0 0 3.51.917c3.952 0 7.167-3.215 7.167-7.166 0-1.238-.315-2.44-.918-3.51L8.49 18.249z"
    }
  }],
  title: "ban"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M23.5 20H.5a.5.5 0 0 1 0-1C1.521 19 3 15.668 3 14.255v-3.788c0-3.815 2.083-5.556 5.24-6.92C8.393 1.502 9.926 0 11.926 0c2.024 0 3.633 1.532 3.795 3.546C18.902 4.921 21 6.665 21 10.467v3.788C21 15.706 22.453 19 23.5 19a.5.5 0 0 1 0 1zM2.17 19h19.66C20.736 17.674 20 15.37 20 14.255v-3.788c0-3.376-1.897-4.846-4.957-6.122a.5.5 0 0 1-.308-.462C14.735 2.267 13.501 1 11.926 1c-1.538 0-2.698 1.239-2.698 2.883a.502.502 0 0 1-.308.462C5.883 5.61 4 7.076 4 10.467v3.788C4 15.37 3.264 17.674 2.17 19z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M12 23.64a3.978 3.978 0 0 1-3.973-3.973.5.5 0 0 1 1 0c0 1.639 1.333 2.973 2.973 2.973s2.973-1.334 2.973-2.973a.5.5 0 0 1 1 0A3.978 3.978 0 0 1 12 23.64z"
    }
  }],
  title: "bell"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M21.952 24H2.048A2.05 2.05 0 0 1 0 21.953V2.5A.5.5 0 0 1 .5 2H5a.5.5 0 0 1 0 1H1v18.953C1 22.53 1.47 23 2.048 23h19.904C22.53 23 23 22.53 23 21.953V3h-2a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .5.5v19.453A2.05 2.05 0 0 1 21.952 24z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M8.5 4h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5zM6 3h2V1H6v2zm14.5 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5zM18 3h2V1h-2v2z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M17 3H9a.5.5 0 0 1 0-1h8a.5.5 0 0 1 0 1zM0 6h23v1H0zm8.5 13.5A.5.5 0 0 1 8 19v-6.571l-1.201 1.027a.5.5 0 1 1-.65-.76l2.026-1.732a.499.499 0 0 1 .825.38V19a.5.5 0 0 1-.5.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M11 20H6a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1zm3.351-.152a.5.5 0 0 1-.47-.671L16.5 12H13a.5.5 0 0 1-1 0v-.5a.5.5 0 0 1 .5-.5h4.715c.163 0 .316.08.41.213a.505.505 0 0 1 .06.458l-2.864 7.848a.502.502 0 0 1-.47.329z"
    }
  }],
  title: "calendar"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M.5 15.5A.5.5 0 0 1 0 15v-5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.5.5zm23 7a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 1 0v20a.5.5 0 0 1-.5.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M23.5 21.806a.517.517 0 0 1-.151-.023l-23-7.319A.503.503 0 0 1 0 13.986v-3.138c0-.218.141-.41.348-.477l23-7.319a.5.5 0 0 1 .652.477v17.776c0 .159-.076.31-.205.403a.5.5 0 0 1-.295.098zM1 13.621l22 7.001V4.213L1 11.214v2.407z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M9.677 21.434C6.638 21.434 6 19.722 6 18.285V16a.5.5 0 0 1 1 0v2.285c0 1 .304 2.148 2.677 2.148 1.776 0 2.677-.776 2.677-2.309a.5.5 0 0 1 1 0c0 2.104-1.341 3.31-3.677 3.31z"
    }
  }],
  title: "campaigns"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M7.217 23.5a.503.503 0 0 1-.354-.146L.646 17.137a.5.5 0 0 1 .707-.707l5.801 5.801L22.594.708a.5.5 0 0 1 .813.583l-15.783 22a.5.5 0 0 1-.366.207c-.013.002-.027.002-.041.002z"
    }
  }],
  title: "check"
}, {
  name: "svg",
  attrs: {
    width: "11",
    height: "11",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg"
  },
  childs: [{
    name: "title",
    attrs: {},
    childs: [{
      text: "status/mixed"
    }]
  }, {
    name: "g",
    attrs: {
      fill: "none",
      fillRule: "evenodd"
    },
    childs: [{
      name: "path",
      attrs: {
        d: "M5.5 0v11a5.5 5.5 0 0 1 0-11z",
        fill: "#00C479"
      }
    }, {
      name: "path",
      attrs: {
        d: "M5.5 11V0a5.5 5.5 0 0 1 0 11z",
        fill: "#E0E0E0"
      }
    }]
  }],
  title: "checkmark-mixed"
}, {
  name: "svg",
  attrs: {
    width: "11",
    height: "11",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg"
  },
  childs: [{
    name: "title",
    attrs: {},
    childs: [{
      text: "status/not running"
    }]
  }, {
    name: "path",
    attrs: {
      d: "M5.5 11a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11z",
      fill: "#E0E0E0"
    }
  }],
  title: "checkmark-not-running"
}, {
  name: "svg",
  attrs: {
    width: "11",
    height: "11",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg"
  },
  childs: [{
    name: "title",
    attrs: {},
    childs: [{
      text: "status/running"
    }]
  }, {
    name: "g",
    attrs: {
      fill: "none"
    },
    childs: [{
      name: "path",
      attrs: {
        d: "M5.5 11a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11z",
        fill: "#00C479"
      }
    }, {
      name: "path",
      attrs: {
        d: "M3.205 5.72a.66.66 0 0 0-.91.956L3.77 8.082a.66.66 0 0 0 .894.016l4.43-3.938a.66.66 0 1 0-.878-.987L4.242 6.707 3.205 5.72z",
        fill: "#FFF"
      }
    }]
  }],
  title: "checkmark-running"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M20.5 24h-16a.5.5 0 0 1-.5-.5v-20a.5.5 0 0 1 .5-.5H8a.5.5 0 0 1 0 1H5v19h15V4h-3a.5.5 0 0 1 0-1h3.5a.5.5 0 0 1 .5.5v20a.5.5 0 0 1-.5.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M16.5 7h-8a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1.521c.176-2 1.445-2 2.479-2s2.303 0 2.479 2H16.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5zM9 6h7V3h-1.5a.5.5 0 0 1-.5-.5C14 1 13.592 1 12.5 1S11 1 11 2.5a.5.5 0 0 1-.5.5H9v3z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M18.5 21h-12a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5H8a.5.5 0 0 1 0 1H7v14h11V6h-1a.5.5 0 0 1 0-1h1.5a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5z"
    }
  }],
  title: "clipboard"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M20.667 21.167a.502.502 0 0 1-.354-.146L2.98 3.687a.5.5 0 0 1 .707-.707L21.02 20.313a.5.5 0 0 1-.353.854z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M3.333 21.167a.5.5 0 0 1-.354-.853L20.313 2.98a.5.5 0 0 1 .707.707L3.687 21.02a.5.5 0 0 1-.354.147z"
    }
  }],
  title: "close"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M6.622 12.669a.5.5 0 0 1-.354-.853l2.19-2.19-2.19-2.19a.5.5 0 0 1 .707-.707L9.52 9.272a.5.5 0 0 1 0 .707l-2.544 2.543a.5.5 0 0 1-.354.147zM17 11h-5a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M23.5 22H.5a.5.5 0 0 1-.5-.5v-20A.5.5 0 0 1 .5 1h23a.5.5 0 0 1 .5.5v20a.5.5 0 0 1-.5.5zM1 21h22V2H1v19z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M20.5 19h-17a.5.5 0 0 1-.5-.5v-14a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5zM4 18h16V5H4v13z"
    }
  }],
  title: "code"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M5.444 9.5a3.332 3.332 0 0 1-3.328-3.328c0-1.835 1.493-3.329 3.328-3.329s3.328 1.493 3.328 3.329A3.332 3.332 0 0 1 5.444 9.5zm0-5.657a2.33 2.33 0 0 0-2.328 2.329C3.116 7.456 4.16 8.5 5.444 8.5s2.328-1.044 2.328-2.328a2.33 2.33 0 0 0-2.328-2.329zM7.5 22h-4a.5.5 0 0 1-.5-.5v-4.603C2.046 15.976.5 13.675.5 10.5A.5.5 0 0 1 1 10h8.889a.5.5 0 0 1 .5.5c0 2.858-1.207 5.265-2.389 6.398V21.5a.5.5 0 0 1-.5.5zM4 21h3v-4.323a.5.5 0 0 1 .175-.38c.838-.715 2.06-2.68 2.2-5.296h-7.86c.151 2.557 1.432 4.546 2.311 5.296.11.095.174.234.174.38V21zM18.556 9.5a3.332 3.332 0 0 1-3.328-3.328c0-1.835 1.493-3.329 3.328-3.329s3.328 1.493 3.328 3.329A3.332 3.332 0 0 1 18.556 9.5zm0-5.657a2.33 2.33 0 0 0-2.328 2.329c0 1.284 1.044 2.328 2.328 2.328s2.328-1.044 2.328-2.328a2.331 2.331 0 0 0-2.328-2.329zM20.5 22h-4a.5.5 0 0 1-.5-.5v-4.602c-1.182-1.133-2.389-3.54-2.389-6.398a.5.5 0 0 1 .5-.5H23a.5.5 0 0 1 .5.5c0 3.175-1.546 5.476-2.5 6.397V21.5a.5.5 0 0 1-.5.5zM17 21h3v-4.323a.5.5 0 0 1 .175-.38c.879-.75 2.159-2.74 2.311-5.296h-7.86c.141 2.617 1.362 4.581 2.2 5.296.11.095.175.234.175.38V21z"
    }
  }],
  title: "collaborators"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M15 9.5a.5.5 0 0 1-.354-.853l8-8a.5.5 0 0 1 .707.707l-8 8A.498.498 0 0 1 15 9.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M19.5 10h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 1 0V9h4.5a.5.5 0 0 1 0 1zM1 23.5a.5.5 0 0 1-.354-.853l8-8a.5.5 0 0 1 .707.707l-8 8A.498.498 0 0 1 1 23.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M9.5 20a.5.5 0 0 1-.5-.5V15H4.5a.5.5 0 0 1 0-1h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5zM23 23.5a.502.502 0 0 1-.354-.146l-8-8a.5.5 0 0 1 .707-.707l8 8A.5.5 0 0 1 23 23.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M14.5 20a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1H15v4.5a.5.5 0 0 1-.5.5zM9 9.5a.502.502 0 0 1-.354-.146l-8-8a.5.5 0 0 1 .707-.707l8 8A.5.5 0 0 1 9 9.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M9.5 10h-5a.5.5 0 0 1 0-1H9V4.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.5.5z"
    }
  }],
  title: "collapse"
}, {
  name: "svg",
  attrs: {
    viewBox: "0 0 1792 1792",
    xmlns: "http://www.w3.org/2000/svg"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M704 384q-153 0-286 52T206.5 577 128 768q0 82 53 158t149 132l97 56-35 84q34-20 62-39l44-31 53 10q78 14 153 14 153 0 286-52t211.5-141 78.5-191-78.5-191T990 436t-286-52zm0-128q191 0 353.5 68.5T1314 511t94 257-94 257-256.5 186.5T704 1280q-86 0-176-16-124 88-278 128-36 9-86 16h-3q-11 0-20.5-8t-11.5-21q-1-3-1-6.5t.5-6.5 2-6l2.5-5 3.5-5.5 4-5 4.5-5 4-4.5q5-6 23-25t26-29.5 22.5-29 25-38.5 20.5-44q-124-72-195-177T0 768q0-139 94-257t256.5-186.5T704 256zm822 1169q10 24 20.5 44t25 38.5 22.5 29 26 29.5 23 25q1 1 4 4.5t4.5 5 4 5 3.5 5.5l2.5 5 2 6 .5 6.5-1 6.5q-3 14-13 22t-22 7q-50-7-86-16-154-40-278-128-90 16-176 16-271 0-472-132 58 4 88 4 161 0 309-45t264-129q125-92 192-212t67-254q0-77-23-152 129 71 204 178t75 230q0 120-71 224.5T1526 1425z"
    }
  }],
  title: "comments"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M20.9 24h-17c-.3 0-.5-.2-.5-.5V.5c0-.3.3-.5.5-.5h10.6c.1 0 .3.1.4.1l6.4 6.3c.1.1.1.2.1.4v16.7c0 .3-.2.5-.5.5zM4.4 23h16V7l-6.1-6H4.4v22z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M20.4 7h-5.5c-.3 0-.5-.2-.5-.5V1c0-.3.2-.5.5-.5s.5.2.5.5v5h5c.3 0 .5.2.5.5s-.2.5-.5.5z"
    }
  }, {
    name: "circle",
    attrs: {
      cx: "7.9",
      cy: "16.6",
      r: ".5"
    }
  }, {
    name: "path",
    attrs: {
      d: "M7.9 17.6c-.5 0-1-.4-1-1 0-.5.4-1 1-1 .5 0 1 .4 1 1s-.4 1-1 1zm0-1.1s0 .1 0 0c0 .2.1.2 0 0 .1.1.1 0 0 0z"
    }
  }, {
    name: "circle",
    attrs: {
      cx: "11.1",
      cy: "14",
      r: ".5"
    }
  }, {
    name: "path",
    attrs: {
      d: "M11.1 15c-.5 0-1-.4-1-1 0-.5.4-1 1-1 .5 0 1 .4 1 1-.1.5-.5 1-1 1zm0-1.1c-.1 0-.1.1 0 0-.1.2.1.2 0 0 .1.1 0 0 0 0z"
    }
  }, {
    name: "circle",
    attrs: {
      cx: "14.2",
      cy: "15.1",
      r: ".5"
    }
  }, {
    name: "path",
    attrs: {
      d: "M14.2 16c-.5 0-1-.4-1-1 0-.5.4-1 1-1 .5 0 1 .4 1 1s-.5 1-1 1zm0-1s-.1 0 0 0c-.1.2.1.2 0 0 .1 0 .1 0 0 0z"
    }
  }, {
    name: "circle",
    attrs: {
      cx: "17.3",
      cy: "11.4",
      r: ".5"
    }
  }, {
    name: "path",
    attrs: {
      d: "M17.3 12.4c-.5 0-1-.4-1-1 0-.5.4-1 1-1 .5 0 1 .4 1 1 0 .5-.4 1-1 1zm0-1.1s0 .1 0 0c0 .2.1.2 0 0 .1.1.1 0 0 0zm-9 5.4c-.1 0-.3-.1-.3-.2-.2-.2-.1-.5.1-.6l2.3-1.9c.2-.2.5-.1.6.1.2.2.1.5-.1.6l-2.3 1.9c-.1.1-.2.1-.3.1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M13.7 15.3h-.1l-2.2-.7c-.2-.1-.4-.3-.3-.6.1-.2.3-.4.6-.3l2.2.7c.2.1.4.3.3.6-.1.2-.3.3-.5.3z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M14.5 15.1c-.1 0-.2 0-.3-.1-.2-.2-.2-.4 0-.6l2.5-2.9c.2-.2.4-.2.6 0 .2.2.2.4 0 .6L14.9 15c-.1.1-.2.1-.4.1z"
    }
  }],
  title: "create-ab"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M.9 17.3c-.3 0-.5-.2-.5-.5V2.3c0-.3.2-.5.5-.5h5c.1 0 .3.1.4.1l1.9 1.9H19c.3 0 .5.2.5.5v.5c0 .3-.2.5-.5.5s-.5-.2-.5-.5H7.9c-.1 0-.3-.1-.4-.1L5.7 2.8H1.4v14c0 .3-.2.5-.5.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M2.9 19.3c-.3 0-.5-.2-.5-.5V6.3c0-.3.2-.5.5-.5h18c.3 0 .5.2.5.5v.5c0 .3-.2.5-.5.5s-.5-.2-.5-.5h-17v12c0 .3-.2.5-.5.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M22.9 20.8h-18c-.3 0-.5-.2-.5-.5v-12c0-.3.2-.5.5-.5h18c.3 0 .5.2.5.5v12c0 .3-.2.5-.5.5zm-17.5-1h17v-11h-17v11z"
    }
  }, {
    name: "circle",
    attrs: {
      cx: "8.9",
      cy: "17.2",
      r: ".6"
    }
  }, {
    name: "path",
    attrs: {
      d: "M8.9 18.3c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1 1.1.5 1.1 1.1-.5 1.1-1.1 1.1zm0-1.2s-.1.1 0 0c-.1.2.1.2 0 0 .1.1.1 0 0 0z"
    }
  }, {
    name: "circle",
    attrs: {
      cx: "12.5",
      cy: "14.2",
      r: ".6"
    }
  }, {
    name: "path",
    attrs: {
      d: "M12.5 15.3c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1 1.1.5 1.1 1.1-.5 1.1-1.1 1.1zm0-1.2c-.1 0-.1.1 0 0-.1.2.1.2 0 0 .1.1 0 0 0 0z"
    }
  }, {
    name: "circle",
    attrs: {
      cx: "16.1",
      cy: "15.4",
      r: ".6"
    }
  }, {
    name: "path",
    attrs: {
      d: "M16.1 16.5c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1 1.1.5 1.1 1.1-.5 1.1-1.1 1.1zm0-1.2c-.1 0-.1.1 0 0-.1.2.1.2 0 0 .1.1 0 0 0 0z"
    }
  }, {
    name: "circle",
    attrs: {
      cx: "19.7",
      cy: "11.2",
      r: ".6"
    }
  }, {
    name: "path",
    attrs: {
      d: "M19.7 12.3c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1 1.1.5 1.1 1.1-.5 1.1-1.1 1.1zm0-1.2c-.1 0-.1.1 0 0-.1.2 0 .2 0 0 0 .1 0 0 0 0zM9.4 17.3c-.1 0-.3-.1-.4-.2-.2-.2-.1-.5.1-.7l2.7-2.2c.2-.2.5-.1.7.1.2.2.1.5-.1.7l-2.7 2.2c-.1.1-.2.1-.3.1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M15.5 15.7h-.2l-2.5-.8c-.3-.1-.4-.4-.3-.6.1-.3.4-.4.6-.3l2.5.8c.3.1.4.4.3.6 0 .2-.2.3-.4.3zm1-.2c-.1 0-.2 0-.3-.1-.2-.2-.2-.5-.1-.7l2.8-3.3c.2-.2.5-.2.7-.1.2.2.2.5.1.7l-2.8 3.3c-.2.1-.3.2-.4.2z"
    }
  }],
  title: "create-campaign"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M21.5 11.4h-8c-.3 0-.1-.6-.1-.8V.6c0-.3-.2-.2.1-.2H19c.1 0 .2-.1.3-.1l2.7 2c.1.1.4.2.4.3v7.9c0 .4-.6.9-.9.9zm-7.1-1h7V2.9l-2.6-1.5h-4.4v9z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M21 4.4h-2.5c-.3 0-.1-.6-.1-.8V1.1c0-.3.2-.5.5-.5s.5.2.5.5v2.3H21c.3 0 .5.2.5.5s-.2.5-.5.5zm-10.5 7h-8c-.3 0-.1-.6-.1-.8V.6c0-.3-.2-.2.1-.2H8c.1 0 .2-.1.3-.1l2.7 2c.1.1.4.2.4.3v7.9c0 .4-.6.9-.9.9zm-7.1-1h7V2.9L7.8 1.4H3.4v9z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M10 4.4H7.5c-.3 0-.1-.6-.1-.8V1.1c0-.3.2-.5.5-.5s.5.2.5.5v2.3H10c.3 0 .5.2.5.5s-.2.5-.5.5zm11.5 20h-8c-.3 0-.1-.6-.1-.8v-10c0-.3-.2-.2.1-.2H19c.1 0 .2-.1.3-.1l2.7 2c.1.1.4.2.4.3v7.9c0 .4-.6.9-.9.9zm-7.1-1h7v-7.5l-2.6-1.5h-4.4v9z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M21 17.4h-2.5c-.3 0-.1-.6-.1-.8v-2.5c0-.3.2-.5.5-.5s.5.2.5.5v2.3H21c.3 0 .5.2.5.5s-.2.5-.5.5zm-10.5 7h-8c-.3 0-.1-.6-.1-.8v-10c0-.3-.2-.2.1-.2H8c.1 0 .2-.1.3-.1l2.7 2c.1.1.4.2.4.3v7.9c0 .4-.6.9-.9.9zm-7.1-1h7v-7.5l-2.6-1.5H3.4v9z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M10 17.4H7.5c-.3 0-.1-.6-.1-.8v-2.5c0-.3.2-.5.5-.5s.5.2.5.5v2.3H10c.3 0 .5.2.5.5s-.2.5-.5.5z"
    }
  }],
  title: "create-mvt"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M22 21H2c-1.103 0-2-.937-2-2.088V4.088C0 2.937.897 2 2 2h20c1.103 0 2 .937 2 2.088v14.824C24 20.063 23.103 21 22 21zM2 3c-.552 0-1 .488-1 1.088v14.824c0 .6.448 1.088 1 1.088h20c.552 0 1-.488 1-1.088V4.088C23 3.488 22.552 3 22 3H2zm17 20H5a.5.5 0 0 1 0-1h14a.5.5 0 0 1 0 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M12 23a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 1 0v2a.5.5 0 0 1-.5.5z"
    }
  }, {
    name: "circle",
    attrs: {
      cx: "12",
      cy: "18.5",
      r: "1"
    }
  }, {
    name: "path",
    attrs: {
      d: "M.5 16h23v1H.5z"
    }
  }],
  title: "desktop"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M16.5 24H.5a.5.5 0 0 1-.5-.5v-16A.5.5 0 0 1 .5 7h16a.5.5 0 0 1 .5.5v16a.5.5 0 0 1-.5.5zM1 23h15V8H1v15z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M22.5 17h-16a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5h16a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5zM7 16h15V2H7v14z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M6.231 15.72l.737.677-6.1 6.637-.736-.677zm15.836.454l.76.652-6.046 7.042-.76-.651zM.5 7.969a.5.5 0 0 1-.352-.854l6-5.969a.5.5 0 0 1 .705.708l-6 5.969a.502.502 0 0 1-.353.146zm21.393-6.592l.711.703-5.994 6.06-.71-.702z"
    }
  }],
  title: "dimensions"
}, {
  name: "svg",
  attrs: {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 16.2"
  },
  childs: [{
    name: "path",
    attrs: {
      "class": "st0",
      d: "M16.5 1H15V.5c0-.3-.2-.5-.5-.5h-3c-.3 0-.5.2-.5.5V1h-.3c-.9 0-1.7.4-2.2 1.1C8 1.4 7.2 1 6.3 1H.5c-.3 0-.5.2-.5.5v12c0 .3.2.5.5.5h4.8c1.1 0 2.7.5 2.7 1.7 0 .3.2.5.5.5s.5-.2.5-.5c0-1.2 1.6-1.7 2.7-1.7h4.8c.3 0 .5-.2.5-.5v-12c0-.3-.2-.5-.5-.5zM12 1h2v4.5l-.6-.6c-.2-.2-.5-.2-.7 0l-.7.6V1zM5.3 13H1V2h5.3C7.8 2 8 3.5 8 4.1v9.7c-.8-.5-1.7-.8-2.7-.8zM16 13h-4.3c-1 0-1.9.3-2.7.8V4.1c0-.6.2-2.1 1.7-2.1h.3v4.7c0 .3.2.5.5.5.1 0 .3-.1.4-.1L13 5.9 14.1 7c.2.2.5.2.7 0 .1-.1.2-.2.2-.3V2h1v11z"
    }
  }],
  title: "docs"
}, {
  name: "svg",
  attrs: {
    viewBox: "0 0 1792 1792",
    xmlns: "http://www.w3.org/2000/svg"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28H224q-40 0-68-28t-28-68V96q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528V640h-416q-40 0-68-28t-28-68V128H256v1536h1280zM512 800q0-14 9-23t23-9h704q14 0 23 9t9 23v64q0 14-9 23t-23 9H544q-14 0-23-9t-9-23v-64zm736 224q14 0 23 9t9 23v64q0 14-9 23t-23 9H544q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704zm0 256q14 0 23 9t9 23v64q0 14-9 23t-23 9H544q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704z"
    }
  }],
  title: "document"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M12.5 19.5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 1 0v17a.5.5 0 0 1-.5.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M12.455 19.877a.502.502 0 0 1-.391-.188l-4.27-5.337a.501.501 0 0 1 .781-.625l3.879 4.849 3.878-4.849a.5.5 0 0 1 .781.625l-4.269 5.337a.496.496 0 0 1-.389.188z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M23.5 24H.5a.5.5 0 0 1-.5-.5V18a.5.5 0 0 1 1 0v5h22v-5a.5.5 0 0 1 1 0v5.5a.5.5 0 0 1-.5.5z"
    }
  }],
  title: "download"
}, {
  name: "svg",
  attrs: {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M8 4H1v12h10V7zm1.55 3H8V5.45zm.45 8H2V5h5v3h3z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M12 0H4v3h1V1h6v3h3v8h-2v1h3V3zm0 1.45L13.55 3H12z"
    }
  }],
  title: "duplicate"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M12.5 13h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5zM2 12h10V2H2v10z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M22.5 23h-12a.5.5 0 0 1-.5-.5V15h1v7h11V12h-7v-1h7.5a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5zm-16.504.196a.5.5 0 0 1-.354-.853l1.568-1.568-1.568-1.569a.5.5 0 0 1 .707-.707l1.922 1.922a.5.5 0 0 1 0 .707L6.35 23.049a.5.5 0 0 1-.354.147z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M7.918 21.274h-.905c-2.77 0-5.023-2.38-5.023-5.305a.5.5 0 0 1 1 0c0 2.374 1.805 4.305 4.023 4.305h.905a.5.5 0 0 1 0 1zM17.922 5.898a.502.502 0 0 1-.354-.146L15.646 3.83a.5.5 0 0 1 0-.707l1.922-1.922a.5.5 0 0 1 .707.707l-1.568 1.568 1.568 1.569a.5.5 0 0 1-.353.853z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M21.519 8.781a.5.5 0 0 1-.5-.5c0-2.374-1.839-4.305-4.099-4.305H16a.5.5 0 0 1 0-1h.92c2.812 0 5.099 2.38 5.099 5.305a.5.5 0 0 1-.5.5z"
    }
  }],
  title: "editor-switch"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "circle",
    attrs: {
      cx: "4",
      cy: "11.5",
      r: "3"
    }
  }, {
    name: "circle",
    attrs: {
      cx: "12.5",
      cy: "11.5",
      r: "3"
    }
  }, {
    name: "circle",
    attrs: {
      cx: "20.5",
      cy: "11.5",
      r: "3"
    }
  }],
  title: "ellipsis"
}, {
  name: "svg",
  attrs: {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M22 6c0-2.5-4.4-4.5-10-4.5S2 3.5 2 6v13c0 2.5 4.4 4.5 10 4.5s10-2 10-4.5V6.5m-10-4c5.3 0 9 1.8 9 3.5s-3.7 3.5-9 3.5C6.6 9.5 3 7.7 3 6s3.6-3.5 9-3.5zm0 20c-5.3 0-9-1.8-9-3.5v-2.5C4.6 18 8 19 12 19s7.4-1 9-2.5V19c0 1.7-3.7 3.5-9 3.5zm0-4.5c-5.3 0-9-1.8-9-3.5V12c1.6 1.5 5 2.5 9 2.5s7.4-1 9-2.5v2.5c0 1.7-3.7 3.5-9 3.5zm0-4.5c-5.3 0-9-1.8-9-3.5V8c1.6 1.5 5 2.5 9 2.5s7.4-1 9-2.5v2c0 1.7-3.7 3.5-9 3.5z"
    }
  }],
  title: "environment"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M15.289 16.393l-.03-.001a.497.497 0 0 1-.424-.29L12.013 9.96l-3.741 5.234a.502.502 0 0 1-.866-.094l-1.805-4.209-1.599 1.863a.498.498 0 0 1-.379.175H1v-1h2.393l1.972-2.298a.5.5 0 0 1 .838.129l1.771 4.13L11.7 8.677a.512.512 0 0 1 .454-.207.502.502 0 0 1 .407.289l2.791 6.073 1.632-2.663a.5.5 0 0 1 .426-.239h5.568v1H17.69l-1.975 3.224a.5.5 0 0 1-.426.239z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M22.781 20H1.219A1.226 1.226 0 0 1 0 18.77V1.23C0 .552.547 0 1.219 0h21.562C23.453 0 24 .552 24 1.23v17.54c0 .678-.547 1.23-1.219 1.23zM1.219 1A.225.225 0 0 0 1 1.23v17.54c0 .126.098.23.219.23h21.562a.225.225 0 0 0 .219-.23V1.23a.225.225 0 0 0-.219-.23H1.219z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M23 5H1a.5.5 0 0 1 0-1h22a.5.5 0 0 1 0 1zM2.216 2.082a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm2.062-.017a.495.495 0 1 0 0 .99.495.495 0 0 0 0-.99z"
    }
  }],
  title: "events"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-23C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M12 16.6a1.532 1.532 0 1 0 0 3.066 1.533 1.533 0 1 0 0-3.066zm0-2.067a1 1 0 0 1-1-1v-9.2a1 1 0 1 1 2 0v9.2a1 1 0 0 1-1 1z"
    }
  }],
  title: "exclamation"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M11.816 21.917H4.183A2.185 2.185 0 0 1 2 19.734V4.266c0-1.203.979-2.183 2.183-2.183h7.634c1.203 0 2.183.979 2.183 2.183v2.977a.5.5 0 0 1-1 0V4.266c0-.652-.53-1.183-1.183-1.183H4.183C3.53 3.083 3 3.613 3 4.266v15.469c0 .652.53 1.183 1.183 1.183h7.634c.652 0 1.183-.53 1.183-1.183v-3.026a.5.5 0 0 1 1 0v3.026a2.186 2.186 0 0 1-2.184 2.182z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M20.45 12.5H7.944a.5.5 0 0 1 0-1H20.45a.5.5 0 0 1 0 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M18.194 16.424a.5.5 0 0 1-.39-.812L20.692 12l-2.889-3.611a.5.5 0 0 1 .781-.625l3.139 3.924a.5.5 0 0 1 0 .625l-3.139 3.924a.5.5 0 0 1-.39.187z"
    }
  }],
  title: "exit"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M19.409 24h-.004l-15.727-.009a2.16 2.16 0 0 1-1.919-1.149c-.374-.685-.325-1.547.129-2.256l3.051-4.606L8 11.502V.5a.498.498 0 0 1 .71-.453l1.679.781c.97.554 2.035.552 2.965.02l1.955-.81A.5.5 0 0 1 16 .5v10.744l5.309 9.429c.414.681.428 1.505.029 2.212S20.219 24 19.409 24zm0-1a1.19 1.19 0 0 0 1.058-.606 1.19 1.19 0 0 0-.021-1.223l-5.381-9.554a.48.48 0 0 1-.065-.242V1.247l-1.206.497c-1.187.686-2.617.687-3.864-.029L9 1.283v10.373c0 .101-.03.199-.087.282L5.768 16.54l-3.043 4.595c-.256.401-.29.865-.088 1.235.22.403.593.635 1.037.636L19.409 23zM8.5 12h.01-.01z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M5.782 1.479L5.335.584 6.502 0h2.027v1H6.738zm12.43-.002L17.272 1h-1.819V0h2.059l1.153.585z"
    }
  }, {
    name: "ellipse",
    attrs: {
      transform: "rotate(-9.132 11.659 8.9)",
      cx: "11.66",
      cy: "8.9",
      rx: "1.56",
      ry: "1.56"
    }
  }, {
    name: "ellipse",
    attrs: {
      transform: "rotate(-9.132 14.217 19.497)",
      cx: "14.22",
      cy: "19.5",
      rx: "1.5",
      ry: "1.5"
    }
  }, {
    name: "ellipse",
    attrs: {
      transform: "rotate(-9.091 12.652 15.035)",
      cx: "12.653",
      cy: "15.036",
      rx: ".98",
      ry: ".98"
    }
  }],
  title: "experiment"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M17.5 24h-2a.5.5 0 0 1-.5-.5v-1.71l-.299-.076a9.65 9.65 0 0 1-.937-.272l-1.199 1.266a.501.501 0 0 1-.352.156.448.448 0 0 1-.359-.141l-1.845-1.789a.502.502 0 0 1 .008-.725l1.192-1.105c-.17-.272-.32-.562-.432-1.103H9.5A.502.502 0 0 1 9 17.5v-2a.5.5 0 0 1 .5-.5h1.364c.03-.12.063-.263.091-.383.106-.46.198-.839.305-1.13l-1.29-1.453a.501.501 0 0 1 .019-.685l1.832-1.845a.471.471 0 0 1 .356-.147.5.5 0 0 1 .355.149l1.225 1.246c.281-.107.614-.198.92-.281l.322-.088V9.5A.502.502 0 0 1 15.5 9h2a.5.5 0 0 1 .5.5v.777a4.476 4.476 0 0 1 1.36.48l1.257-1.211a.502.502 0 0 1 .705.012l1.845 1.894a.5.5 0 0 1 .007.69l-1.269 1.354c.105.289.197.664.304 1.118.028.121.062.266.093.386H23.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1.112a3.066 3.066 0 0 1-.426 1.088l1.164.996a.5.5 0 0 1 .028.734l-1.853 1.845a.502.502 0 0 1-.705.001l-1.243-1.229c-.335.178-.739.339-1.354.456V23.5a.499.499 0 0 1-.499.5zM16 23h1v-1.534a.5.5 0 0 1 .432-.495c.937-.128 1.328-.332 1.742-.586a.504.504 0 0 1 .613.071l1.161 1.148 1.117-1.113-1.083-.926a.501.501 0 0 1-.102-.641l.141-.222c.21-.324.349-.538.45-1.271a.5.5 0 0 1 .495-.431H23v-1h-1.035c-.459 0-.55-.387-.731-1.157-.093-.396-.233-.995-.35-1.186a.5.5 0 0 1 .062-.603l1.17-1.247-1.164-1.195-1.171 1.128a.5.5 0 0 1-.607.066c-.475-.29-.853-.489-1.742-.61a.5.5 0 0 1-.432-.495V10h-1v.701c0 .447-.376.55-1.06.735-.355.096-.841.229-1.033.345a.495.495 0 0 1-.616-.076l-1.117-1.137-1.145 1.153 1.193 1.344a.501.501 0 0 1 .053.593c-.116.189-.254.788-.346 1.185-.179.77-.268 1.157-.729 1.157H10v1h1.2c.25 0 .461.185.496.433.101.736.231.939.449 1.276l.137.216a.499.499 0 0 1-.087.627l-1.111 1.03 1.104 1.07 1.097-1.158a.505.505 0 0 1 .624-.083c.191.117.702.248 1.04.334.655.167 1.051.268 1.051.721V23z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M16.583 19.518c-1.894 0-3.435-1.541-3.435-3.435s1.541-3.435 3.435-3.435 3.435 1.541 3.435 3.435-1.541 3.435-3.435 3.435zm0-5.87c-1.342 0-2.435 1.092-2.435 2.435s1.092 2.435 2.435 2.435 2.435-1.092 2.435-2.435-1.092-2.435-2.435-2.435z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M6 20H2.5A2.503 2.503 0 0 1 0 17.5v-14C0 2.121 1.122 1 2.5 1h19C22.878 1 24 2.121 24 3.5V9a.5.5 0 0 1-1 0V3.5c0-.827-.673-1.5-1.5-1.5h-19C1.673 2 1 2.673 1 3.5v14c0 .827.673 1.5 1.5 1.5H6a.5.5 0 0 1 0 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M23 7H1a.5.5 0 0 1 0-1h22a.5.5 0 0 1 0 1zM4 5a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2zm0-1.001s0 .001 0 0L4.5 4 4 3.999zM7 5a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2zm0-1.001s0 .001 0 0L7.5 4 7 3.999zM10 5a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2zm0-1.001s0 .001 0 0l.5.001-.5-.001z"
    }
  }],
  title: "extensions"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M18.5 24H.5a.5.5 0 0 1-.5-.5v-18A.5.5 0 0 1 .5 5H9a.5.5 0 0 1 0 1H1v17h17v-8a.5.5 0 0 1 1 0v8.5a.5.5 0 0 1-.5.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M5.073 19.427a.5.5 0 0 1-.354-.853L23.011.282a.5.5 0 0 1 .707.707L5.427 19.281a.502.502 0 0 1-.354.146z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M23.5 11.5a.5.5 0 0 1-.5-.5V1H13a.5.5 0 0 1 0-1h10.5a.5.5 0 0 1 .5.5V11a.5.5 0 0 1-.5.5z"
    }
  }],
  title: "external"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M12 19C5.481 19 .324 12.584.108 12.311a.5.5 0 0 1 0-.621C.324 11.416 5.481 5 12 5s11.676 6.416 11.892 6.689a.5.5 0 0 1 0 .621C23.676 12.584 18.519 19 12 19zM1.155 12C2.266 13.271 6.753 18 12 18s9.734-4.729 10.845-6C21.734 10.729 17.247 6 12 6s-9.734 4.729-10.845 6z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M12 16.5c-2.481 0-4.5-2.019-4.5-4.5S9.519 7.5 12 7.5s4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5zm0-8c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5z"
    }
  }],
  title: "eye"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M12 18.95c-1.03 0-2.089-.164-3.148-.486a.5.5 0 1 1 .292-.957A9.793 9.793 0 0 0 12 17.95c5.248 0 9.736-4.73 10.846-6.001a22.411 22.411 0 0 0-3.621-3.306.5.5 0 1 1 .586-.81c2.467 1.784 4.017 3.725 4.082 3.807a.5.5 0 0 1 0 .621c-.217.273-5.374 6.689-11.893 6.689zm-7.533-2.799a.5.5 0 0 1-.293-.095C1.716 14.275.172 12.341.108 12.26a.5.5 0 0 1 0-.621C.324 11.366 5.481 4.95 12 4.95c.859 0 1.744.114 2.628.341a.499.499 0 1 1-.248.968A9.691 9.691 0 0 0 12 5.95c-5.248 0-9.736 4.73-10.846 6 .53.609 1.83 2.009 3.607 3.296a.5.5 0 0 1-.294.905z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M8 12.45a.5.5 0 0 1-.5-.5c0-2.481 2.019-4.5 4.5-4.5a.5.5 0 0 1 0 1c-1.93 0-3.5 1.57-3.5 3.5a.5.5 0 0 1-.5.5zm4 4a.5.5 0 0 1 0-1c1.93 0 3.5-1.57 3.5-3.5a.5.5 0 0 1 1 0c0 2.482-2.019 4.5-4.5 4.5zM2.25 22.2a.5.5 0 0 1-.354-.853l19.5-19.5a.5.5 0 0 1 .707.707l-19.5 19.5a.498.498 0 0 1-.353.146z"
    }
  }],
  title: "eye-closed"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M5.5 23.5A.5.5 0 0 1 5 23V1a.5.5 0 0 1 1 0v22a.5.5 0 0 1-.5.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M5.5 14.5A.501.501 0 0 1 5 14V1a.501.501 0 0 1 .699-.459l15 6.5a.5.5 0 0 1 0 .918l-15 6.5a.514.514 0 0 1-.199.041zM6 1.762v11.477L19.242 7.5 6 1.762z"
    }
  }],
  title: "feature-flag"
}, {
  name: "svg",
  attrs: {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M16.4 14.7h-8c-1.7 0-3-1.3-3-3s1.3-3 3-3h8c1.7 0 3 1.3 3 3s-1.4 3-3 3zm-8-5c-1.1 0-2 .9-2 2s.9 2 2 2h8c1.1 0 2-.9 2-2s-.9-2-2-2h-8zm8 12h-8c-1.7 0-3-1.3-3-3s1.3-3 3-3h8c1.7 0 3 1.3 3 3s-1.4 3-3 3zm-8-5c-1.1 0-2 .9-2 2s.9 2 2 2h8c1.1 0 2-.9 2-2s-.9-2-2-2h-8z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M15.9 19.7c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1c0 .5-.5 1-1 1zm-7-7c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1c0 .5-.5 1-1 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M20.9 24h-17c-.3 0-.5-.2-.5-.5V.5c0-.3.3-.5.5-.5h10.6c.1 0 .3.1.4.1l6.4 6.3c.1.1.1.2.1.4v16.7c0 .3-.2.5-.5.5zM4.4 23h16V7l-6.1-6H4.4v22z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M20.4 7h-5.5c-.3 0-.5-.2-.5-.5V1c0-.3.2-.5.5-.5s.5.2.5.5v5h5c.3 0 .5.2.5.5s-.2.5-.5.5z"
    }
  }],
  title: "feature-test"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M9.5 22.448a.5.5 0 0 1-.5-.5V16H2.033C1.425 16 0 16 0 14.57V2.033C0 .912.912 0 2.033 0H21.98C23.094 0 24 .912 24 2.033V14.57C24 16 22.585 16 21.98 16h-6.67c-.555.726-1.974 2.342-5.434 6.278a.5.5 0 0 1-.376.17zM2.033 1C1.464 1 1 1.464 1 2.033V14.57c0 .259 0 .43 1.033.43H9.5a.5.5 0 0 1 .5.5v5.122c2.068-2.354 4.565-5.201 4.748-5.422a.503.503 0 0 1 .4-.2h6.832C23 15 23 14.838 23 14.57V2.033C23 1.464 22.543 1 21.98 1H2.033z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M16 5H5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1zm-3 3H5a.5.5 0 0 1 0-1h8a.5.5 0 0 1 0 1zm3 3H5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1z"
    }
  }],
  title: "feedback"
}, {
  name: "svg",
  attrs: {
    viewBox: "0 0 1792 1792",
    xmlns: "http://www.w3.org/2000/svg"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28H224q-40 0-68-28t-28-68V96q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528V640h-416q-40 0-68-28t-28-68V128H256v1536h1280z"
    }
  }],
  title: "file"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M20.6 7.4l-3.2-1.1-.9-4.9c0-.2-.2-.4-.4-.4s-.4.1-.5.3c-.5 1.4-1.4 1.9-2.7 2.3-.6.1-1.2.2-1.9.3-1.1.2-2.1.3-3 .5-1.1.3-2.5.8-3.5 2.2l-.6-1c-.1-.3-.4-.4-.7-.2-.2.1-.3.4-.1.7l10.2 17.1c.1.2.3.2.4.2.1 0 .2 0 .3-.1.2-.1.3-.4.2-.7l-5-8.3c.9-1.5 2.2-2 3.2-2.2.8-.2 1.6-.3 2.4-.4.9-.1 1.8-.3 2.6-.5 1.6-.4 2.9-1.1 3.5-3.1.1-.3-.1-.6-.3-.7zm-3.5 2.8c-.8.2-1.6.3-2.5.5-.8.1-1.7.2-2.5.4-1.5.3-2.7 1.1-3.5 2.2L5.1 7.5c.8-1.3 2.1-1.9 3.1-2.1.9-.2 1.8-.4 2.7-.5.7-.1 1.4-.2 2-.3 1-.3 2-.7 2.7-1.6l.7 3.8c0 .2.2.3.3.4l3 1c-.4 1.2-1.3 1.7-2.5 2z"
    }
  }],
  title: "flag"
}, {
  name: "svg",
  attrs: {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "rect",
    attrs: {
      x: ".5",
      y: "12.5",
      width: "10",
      height: "10",
      rx: "2",
      ry: "2",
      fill: "none",
      stroke: "currentColor"
    }
  }, {
    name: "rect",
    attrs: {
      x: "13.5",
      y: "12.5",
      width: "10",
      height: "10",
      rx: "2",
      ry: "2",
      fill: "none",
      stroke: "currentColor"
    }
  }, {
    name: "rect",
    attrs: {
      x: "6.5",
      y: ".5",
      width: "10",
      height: "10",
      rx: "2",
      ry: "2",
      fill: "none",
      stroke: "currentColor"
    }
  }, {
    name: "path",
    attrs: {
      d: "M3.5 14.5H6a1.5 1.5 0 0 1 0 3H3.5zm0 3H6a1.5 1.5 0 0 1 0 3H3.5zm5.45-9.16l2.57-5.97 2.43 5.97M9.5 6.5h4m7.51 12.97a3 3 0 1 1-.06-4.32",
      fill: "none",
      stroke: "currentColor"
    }
  }],
  title: "getting-started"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M17.5 17H4.843a.5.5 0 0 1-.5-.5c0-1.115 1.021-1.935 2.143-2.5H1.5a.5.5 0 0 1-.5-.5v-12a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5V3h7.5a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5zM5.499 16H17V4H9.5a.5.5 0 0 1-.5-.5V2H2v11h7.438a.5.5 0 0 1 .106.988C8.159 14.291 6.08 15.06 5.499 16z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M9.5 13.979a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 1 0v11.479a.5.5 0 0 1-.5.5zM1.5 24a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 1 0v23a.5.5 0 0 1-.5.5zm2.917-7a.5.5 0 0 1-.5-.5V14a.5.5 0 0 1 1 0v2.5a.5.5 0 0 1-.5.5z"
    }
  }],
  title: "goal"
}, {
  name: "svg",
  attrs: {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M2 19V3H0v18h24v-2z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M5 13h2v4H5zm4-6h2v10H9zm4 3h2v7h-2zm4-5h2v12h-2z"
    }
  }],
  title: "graph"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M22 5H2a1 1 0 0 1 0-2h20a1 1 0 0 1 0 2zm0 8H2a1 1 0 0 1 0-2h20a1 1 0 0 1 0 2zm0 8H2a1 1 0 0 1 0-2h20a1 1 0 0 1 0 2z"
    }
  }],
  title: "hamburger"
}, {
  name: "svg",
  attrs: {
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  },
  childs: [{
    name: "path",
    attrs: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.6 5.583a.4.4 0 0 1 .4-.4h12.222a.4.4 0 0 1 0 .8H2a.4.4 0 0 1-.4-.4zm0 4.584a.4.4 0 0 1 .4-.4h12.222a.4.4 0 0 1 0 .8H2a.4.4 0 0 1-.4-.4z"
    }
  }, {
    name: "path",
    attrs: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.627.602a.4.4 0 0 1 .354.442l-1.528 13.75a.4.4 0 0 1-.795-.088L6.186.956a.4.4 0 0 1 .441-.354zm4.583 0a.4.4 0 0 1 .354.442l-1.528 13.75a.4.4 0 0 1-.795-.088L10.77.956a.4.4 0 0 1 .442-.354z"
    }
  }],
  title: "hash"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M11.936 24C5.354 24 0 18.626 0 12.021 0 5.393 5.354 0 11.936 0 18.588 0 24 5.383 24 12s-5.412 12-12.064 12zm0-23C5.905 1 1 5.943 1 12.021 1 18.074 5.905 23 11.936 23 18.036 23 23 18.065 23 12S18.036 1 11.936 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M10.458 13.336c0-2.457 3.24-2.698 3.24-4.409 0-.786-.623-1.45-1.912-1.45-1.249 0-2.134.543-2.799 1.409l-1.37-1.51c1.028-1.268 2.577-1.993 4.391-1.993 2.538 0 4.088 1.349 4.088 3.161 0 2.98-3.585 3.222-3.585 5.014 0 .321.163.705.444.905l-1.791.605c-.484-.463-.706-1.068-.706-1.732zm.02 4.47c0-.744.643-1.388 1.409-1.388.764 0 1.409.644 1.409 1.388 0 .765-.646 1.43-1.409 1.43-.766 0-1.409-.665-1.409-1.43z"
    }
  }],
  title: "help"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M4.378 15h-.033c-.155 0-.297-.316-.383-.445l-2.878-4.429c-.153-.23-.091-.596.139-.75.229-.153.54-.12.693.111l2.516 3.76L7.36 9.894a.498.498 0 1 1 .753.653l-3.358 4.06c-.096.109-.234.393-.377.393z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M13.827 22c-.268 0-.49-.101-.5-.371-.01-.276.206-.453.481-.463 2.3-.084 4.429-1.032 5.995-2.717s2.382-3.867 2.296-6.165a8.538 8.538 0 0 0-2.745-5.987 8.541 8.541 0 0 0-6.18-2.294c-2.394.088-4.682 1.216-6.278 3.092-1.617 1.9-2.333 4.35-2.017 6.897a.5.5 0 0 1-.993.124c-.352-2.829.447-5.552 2.248-7.668 1.777-2.088 4.329-3.342 7.002-3.44a9.56 9.56 0 0 1 6.897 2.564 9.548 9.548 0 0 1 3.064 6.69c.096 2.566-.814 4.905-2.563 6.786C18.788 20.928 16.412 22 13.846 22h-.019z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M16 14h-3.5a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 1 0v5h3a.5.5 0 0 1 0 1z"
    }
  }],
  title: "history"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M4.173 15.733l-.858-.513 3.209-5.349a.496.496 0 0 1 .39-.241.474.474 0 0 1 .423.178l2.165 2.598 2.345-5.159c.083-.182.281-.281.467-.293.2.005.378.128.453.314l3.209 8.023-.928.371-2.775-6.937-2.19 4.818a.498.498 0 0 1-.839.113L7.02 10.989l-2.847 4.744z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M18.5 19H.5a.5.5 0 0 1-.5-.5V.5A.5.5 0 0 1 .5 0h18a.5.5 0 0 1 .5.5v18a.5.5 0 0 1-.5.5zM1 18h17V1H1v17z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M21.542 23.465l-.046-.002-15.979-1.458a.5.5 0 0 1 .09-.996l15.482 1.413 1.367-14.984-1.633-.148a.5.5 0 0 1-.453-.543.517.517 0 0 1 .543-.453l2.131.193a.498.498 0 0 1 .453.544l-1.458 15.98a.496.496 0 0 1-.497.454z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M0 15h18v1H0zm5.349-7.581a2.106 2.106 0 0 1-2.104-2.105c0-1.16.944-2.104 2.104-2.104s2.105.944 2.105 2.104a2.108 2.108 0 0 1-2.105 2.105zm0-3.21a1.105 1.105 0 1 0 .002 2.21 1.105 1.105 0 0 0-.002-2.21z"
    }
  }],
  title: "image"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-23C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M14.6 17.1a.502.502 0 0 1-.354-.146l-2.776-2.775a.5.5 0 0 1 .707-.707l2.776 2.775a.5.5 0 0 1-.353.853z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M11.5 14.5a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 1 0v7a.5.5 0 0 1-.5.5z"
    }
  }],
  title: "inconclusive"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M8.167 16.333C3.664 16.333 0 12.67 0 8.167S3.664 0 8.167 0s8.166 3.664 8.166 8.167-3.663 8.166-8.166 8.166zM8.167 1C4.215 1 1 4.215 1 8.167s3.215 7.167 7.167 7.167c3.951 0 7.166-3.215 7.166-7.167S12.118 1 8.167 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M15.833 24c-4.503 0-8.166-3.664-8.166-8.167s3.663-8.167 8.166-8.167S24 11.33 24 15.833 20.336 24 15.833 24zm0-15.333c-3.951 0-7.166 3.215-7.166 7.167S11.882 23 15.833 23C19.785 23 23 19.785 23 15.833s-3.215-7.166-7.167-7.166z"
    }
  }],
  title: "integrations"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M5.425 23.999a4.459 4.459 0 0 1-3.173-1.313l-.938-.938C.467 20.9 0 19.774 0 18.576s.467-2.324 1.313-3.171L7.42 9.299a4.454 4.454 0 0 1 3.172-1.314c1.197 0 2.324.467 3.171 1.314l.939.939a.5.5 0 0 1-.707.707l-.939-.939c-1.316-1.319-3.612-1.317-4.929 0l-6.106 6.106A3.458 3.458 0 0 0 1 18.576c0 .931.362 1.806 1.021 2.464l.938.938c1.315 1.315 3.614 1.317 4.93 0l4.229-4.227a.5.5 0 0 1 .707.707l-4.229 4.227a4.45 4.45 0 0 1-3.171 1.314z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M13.409 16.016a4.455 4.455 0 0 1-3.171-1.314.5.5 0 0 1 .707-.707c1.316 1.318 3.612 1.318 4.929 0l6.104-6.105A3.463 3.463 0 0 0 23 5.424c0-.931-.362-1.806-1.021-2.464l-.939-.939a3.493 3.493 0 0 0-4.929 0l-4.227 4.226a.5.5 0 0 1-.707-.707l4.227-4.226a4.492 4.492 0 0 1 6.343 0l.938.939A4.452 4.452 0 0 1 24 5.424a4.456 4.456 0 0 1-1.314 3.172l-6.104 6.105a4.459 4.459 0 0 1-3.173 1.315z"
    }
  }],
  title: "link"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M20.936 24H16.6a.5.5 0 0 1 0-1h4.335A2.067 2.067 0 0 0 23 20.936V3.064A2.066 2.066 0 0 0 20.936 1H16.6a.5.5 0 0 1 0-1h4.335A3.068 3.068 0 0 1 24 3.064v17.871A3.068 3.068 0 0 1 20.936 24zM7.4 24H3.064A3.068 3.068 0 0 1 0 20.936V3.064A3.068 3.068 0 0 1 3.064 0H7.4a.5.5 0 0 1 0 1H3.064A2.066 2.066 0 0 0 1 3.064v17.871C1 22.074 1.926 23 3.064 23H7.4a.5.5 0 0 1 0 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M6.155 15.309c.192-.132.388-.198.588-.198.096 0 .192.013.287.042.097.027.2.073.312.138l.421.228a.548.548 0 0 0 .162.066c.052.012.11.018.174.018.2 0 .354-.049.462-.15.108-.1.386-.451.834-1.051.296-.391.969-1.348 2.017-2.869 0-.055-.092-.485-.276-1.291a54.903 54.903 0 0 0-.504-2.047c-.152-.568-.288-.942-.408-1.122-.12-.181-.344-.27-.672-.27-.112 0-.332.04-.66.121-.208.048-.432.103-.672.168l-.108-.373 1.332-.455c.344-.121.663-.217.955-.289s.542-.108.75-.108c.336 0 .588.1.757.299.256.32.472.954.648 1.897l.252 1.369c.72-1.104 1.281-1.881 1.681-2.328.36-.409.701-.713 1.02-.913.32-.199.624-.299.913-.299.272 0 .492.04.66.12.304.144.456.416.456.816 0 .273-.076.485-.228.636a.794.794 0 0 1-.588.229c-.088 0-.172-.01-.252-.03a1.58 1.58 0 0 1-.252-.091l-.312-.132a3.928 3.928 0 0 0-.252-.102.609.609 0 0 0-.18-.042c-.36 0-.86.467-1.5 1.399-.64.933-.961 1.47-.961 1.614 0 .121.074.511.222 1.171.148.66.31 1.36.486 2.095.16.696.296 1.177.408 1.44.184.433.392.648.624.648.216 0 .436-.12.66-.359.224-.241.56-.672 1.008-1.297l.336.204a10.186 10.186 0 0 1-1.068 1.598c-.696.833-1.361 1.247-1.993 1.247-.401 0-.717-.192-.949-.575-.136-.225-.268-.593-.396-1.105l-.744-2.965-2.461 3.228c-.481.562-.851.937-1.111 1.129-.26.192-.582.288-.966.288-.513 0-.861-.16-1.045-.479a1.129 1.129 0 0 1-.156-.6c.001-.314.096-.536.289-.668z"
    }
  }],
  title: "live-variables"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M20.5 23h-18a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5h18a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5zM3 22h17V8H3v14z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M17.5 7.5A.5.5 0 0 1 17 7v-.845C17 3.409 14.43 1 11.5 1S6 3.409 6 6.155V7a.5.5 0 0 1-1 0v-.845C5 2.818 7.977 0 11.5 0S18 2.818 18 6.155V7a.5.5 0 0 1-.5.5zm-6 10a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M12.867 12.324a1.314 1.314 0 1 1-2.628-.002 1.314 1.314 0 0 1 2.628.002z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M11.554 14.137c-1 0-1.813-.813-1.813-1.813s.813-1.813 1.813-1.813 1.813.813 1.813 1.813-.813 1.813-1.813 1.813zm0-2.626a.814.814 0 1 0 .001 1.625.814.814 0 0 0-.001-1.625z"
    }
  }],
  title: "lock"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-23C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M19.5 17a.5.5 0 0 1-.38-.175l-4.866-5.69-3.9 3.16a.5.5 0 0 1-.684-.051L3.966 8.005a.5.5 0 0 1 .738-.675l5.386 5.891 3.913-3.169a.501.501 0 0 1 .694.063l5.183 6.06a.5.5 0 0 1-.38.825z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M19.5 17H15a.5.5 0 0 1 0-1h4v-5a.5.5 0 0 1 1 0v5.5a.5.5 0 0 1-.5.5z"
    }
  }],
  title: "loser"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M23 13H1a.5.5 0 0 1 0-1h22a.5.5 0 0 1 0 1z"
    }
  }],
  title: "minus"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M16.5 24h-9A2.503 2.503 0 0 1 5 21.5v-19C5 1.121 6.122 0 7.5 0h9C17.878 0 19 1.121 19 2.5v19c0 1.379-1.122 2.5-2.5 2.5zm-9-23C6.673 1 6 1.673 6 2.5v19c0 .827.673 1.5 1.5 1.5h9c.827 0 1.5-.673 1.5-1.5v-19c0-.827-.673-1.5-1.5-1.5h-9z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M18.5 5h-13a.5.5 0 0 1 0-1h13a.5.5 0 0 1 0 1zm0 15h-13a.5.5 0 0 1 0-1h13a.5.5 0 0 1 0 1zm-4 2h-5a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1z"
    }
  }, {
    name: "circle",
    attrs: {
      cx: "12",
      cy: "2.5",
      r: "1"
    }
  }],
  title: "mobile"
}, {
  name: "svg",
  attrs: {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M.5 24c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l23-23c.2-.2.5-.2.7 0s.2.5 0 .7l-23 23c0 .1-.2.1-.3.1zM3 18.2V8h10.2l1-1H6v-.8C6 3.4 8.6 1 11.5 1c2.3 0 4.4 1.5 5.2 3.5l.8-.8c-1-2.2-3.3-3.7-5.9-3.7C8 0 5 2.8 5 6.2V7H2.5c-.3 0-.5.2-.5.5v11.7l1-1zM20.5 7h-.7l-1 1H20v14H4.8l-1 1h16.7c.3 0 .5-.2.5-.5v-15c0-.3-.2-.5-.5-.5z"
    }
  }],
  title: "no-lock"
}, {
  name: "svg",
  attrs: {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "g",
    attrs: {
      opacity: ".3"
    },
    childs: [{
      name: "path",
      attrs: {
        d: "M23.5 13.5a.5.5 0 0 1-.5-.5V2.5A1.5 1.5 0 0 0 21.5 1h-9A1.5 1.5 0 0 0 11 2.5V10a.5.5 0 0 1-1 0V2.5A2.5 2.5 0 0 1 12.5 0h9A2.5 2.5 0 0 1 24 2.5V13a.5.5 0 0 1-.5.5z"
      }
    }, {
      name: "path",
      attrs: {
        d: "M23 5H11a.5.5 0 0 1 0-1h12a.5.5 0 0 1 0 1zm-6-1.5a1 1 0 1 1 1-1 1 1 0 0 1-1 1zM17 2v.5V2z"
      }
    }]
  }, {
    name: "path",
    attrs: {
      d: "M21.5 24h-19A2.5 2.5 0 0 1 0 21.5v-9A2.5 2.5 0 0 1 2.5 10h19a2.5 2.5 0 0 1 2.5 2.5v9a2.5 2.5 0 0 1-2.5 2.5zm-19-13A1.5 1.5 0 0 0 1 12.5v9A1.5 1.5 0 0 0 2.5 23h19a1.5 1.5 0 0 0 1.5-1.5v-9a1.5 1.5 0 0 0-1.5-1.5h-19z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M5.5 23.5A.5.5 0 0 1 5 23V11a.5.5 0 0 1 1 0v12a.5.5 0 0 1-.5.5zm14 0a.5.5 0 0 1-.5-.5V11a.5.5 0 0 1 1 0v12a.5.5 0 0 1-.5.5zm2-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v4a.5.5 0 0 1-.5.5zM3 17.5a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm0-1z"
    }
  }],
  title: "orientation-landscape"
}, {
  name: "svg",
  attrs: {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M21.5 24h-9a2.5 2.5 0 0 1-2.5-2.5v-19A2.5 2.5 0 0 1 12.5 0h9A2.5 2.5 0 0 1 24 2.5v19a2.5 2.5 0 0 1-2.5 2.5zm-9-23A1.5 1.5 0 0 0 11 2.5v19a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5v-19A1.5 1.5 0 0 0 21.5 1h-9z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M23 5H11a.5.5 0 0 1 0-1h12a.5.5 0 0 1 0 1zm0 15H11a.5.5 0 0 1 0-1h12a.5.5 0 0 1 0 1zm-4 2h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1zM17 3.5a1 1 0 1 1 1-1 1 1 0 0 1-1 1zM17 2v.5V2z"
    }
  }, {
    name: "g",
    attrs: {
      opacity: ".3"
    },
    childs: [{
      name: "path",
      attrs: {
        d: "M12 24H2.5A2.5 2.5 0 0 1 0 21.5v-9A2.5 2.5 0 0 1 2.5 10H10a.5.5 0 0 1 0 1H2.5A1.5 1.5 0 0 0 1 12.5v9A1.5 1.5 0 0 0 2.5 23H12a.5.5 0 0 1 0 1z"
      }
    }, {
      name: "path",
      attrs: {
        d: "M5.5 23.5A.5.5 0 0 1 5 23V11a.5.5 0 0 1 1 0v12a.5.5 0 0 1-.5.5zm-2.5-6a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm0-1z"
      }
    }]
  }],
  title: "orientation-portrait"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M18.782 16H1.218A1.219 1.219 0 0 1 0 14.782V1.218C0 .546.546 0 1.218 0h17.564C19.454 0 20 .546 20 1.218v13.564c0 .672-.546 1.218-1.218 1.218zM1.218 1A.219.219 0 0 0 1 1.218v13.564c0 .12.098.218.218.218h17.564c.12 0 .218-.098.218-.218V1.218A.219.219 0 0 0 18.782 1H1.218z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M19 4H1a.5.5 0 0 1 0-1h18a.5.5 0 0 1 0 1zm4 5h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M22.682 20H4.218C3.558 20 3 19.424 3 18.742V18a.5.5 0 0 1 1 0v.742c0 .13.107.258.218.258h18.464c.14 0 .318-.16.318-.258V5.218C23 5.14 22.84 5 22.682 5H22a.5.5 0 0 1 0-1h.682C23.306 4 24 4.5 24 5.218v13.524C24 19.4 23.372 20 22.682 20z"
    }
  }],
  title: "pages"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M10.5 24C7 24 7 20.237 7 19V6.5C7 2.43 8.869 0 12 0s5 2.43 5 6.5V15a.5.5 0 0 1-1 0V6.5c0-2.054-.52-5.5-4-5.5S8 4.446 8 6.5V19c0 3.525 1.264 4 2.5 4s2.5-.475 2.5-4l.001-9.786c.003-.872.006-1.695-.309-2.01C12.643 7.153 12.49 7 12 7s-.642.153-.692.204c-.314.315-.308 1.138-.308 2.01V18a.5.5 0 0 1-1 0l-.001-8.783c-.004-1.132-.008-2.11.6-2.72.329-.33.8-.497 1.401-.497s1.072.167 1.401.498c.607.609.599 1.587.599 2.719V19c0 1.237 0 5-3.5 5z"
    }
  }],
  title: "paperclip"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M23 21H12.927C9.521 21 6 19.094 6 15.903V5a.5.5 0 0 1 1 0v10.903C7 18.729 10.466 20 12.927 20H23a.5.5 0 0 1 0 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M12 11.119a.502.502 0 0 1-.354-.146L6.5 5.826l-5.146 5.146a.5.5 0 0 1-.707-.707l5.5-5.5a.5.5 0 0 1 .707 0l5.5 5.5a.5.5 0 0 1-.354.854z"
    }
  }],
  title: "parent-selector"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M10.5 24h-6a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v23a.5.5 0 0 1-.5.5zM5 23h5V1H5v22zm15.5 1h-6a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v23a.5.5 0 0 1-.5.5zM15 23h5V1h-5v22z"
    }
  }],
  title: "pause"
}, {
  name: "svg",
  attrs: {
    viewBox: "0 0 1792 1792",
    xmlns: "http://www.w3.org/2000/svg"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28H224q-40 0-68-28t-28-68V96q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528V640h-416q-40 0-68-28t-28-68V128H256v1536h1280zm-514-593q33 26 84 56 59-7 117-7 147 0 177 49 16 22 2 52 0 1-1 2l-2 2v1q-6 38-71 38-48 0-115-20t-130-53q-221 24-392 83-153 262-242 262-15 0-28-7l-24-12q-1-1-6-5-10-10-6-36 9-40 56-91.5t132-96.5q14-9 23 6 2 2 2 4 52-85 107-197 68-136 104-262-24-82-30.5-159.5T785 552q11-40 42-40h22q23 0 35 15 18 21 9 68-2 6-4 8 1 3 1 8v30q-2 123-14 192 55 164 146 238zm-576 411q52-24 137-158-51 40-87.5 84t-49.5 74zm398-920q-15 42-2 132 1-7 7-44 0-3 7-43 1-4 4-8-1-1-1-2-1-2-1-3-1-22-13-36 0 1-1 2v2zm-124 661q135-54 284-81-2-1-13-9.5t-16-13.5q-76-67-127-176-27 86-83 197-30 56-45 83zm646-16q-24-24-140-24 76 28 124 28 14 0 18-1 0-1-2-3z"
    }
  }],
  title: "pdf"
}, {
  name: "svg",
  attrs: {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M9.1 4.7L2.7 11l.7.7 6.4-6.3zm-4.969 7.738l6.364-6.364.707.707-6.364 6.364z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M15.5 3.5l-3-3c-.6-.5-1.4-.5-2 0L0 11v5h5L15.5 5.5c.5-.5.5-1.4 0-2zM4.6 15h-1L1 12.4v-1l8.1-8.1 3.6 3.6L4.6 15zM14.8 4.8l-1.4 1.4-3.6-3.6 1.4-1.4c.2-.2.5-.2.7 0l3 3c0 .2 0 .5-.1.6z"
    }
  }],
  title: "pencil"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M.5 24a.503.503 0 0 1-.5-.5V.5A.5.5 0 0 1 .723.053l23 11.5a.5.5 0 0 1 .001.894l-23 11.5A.505.505 0 0 1 .5 24zM1 1.309v21.383L22.382 12 1 1.309z"
    }
  }],
  title: "play"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M2.535 24h-.002c-.534 0-1.036-.458-1.413-.837-.377-.376-.585-1.003-.585-1.537s.208-1.099.585-1.477l6.571-6.602c.188-.188.52-.203.707-.016l2.121 2.113a.496.496 0 0 1 0 .703l-6.57 6.819c-.377.377-.88.834-1.414.834zm5.51-9.425l-6.217 6.218a.994.994 0 0 0-.293.708c0 .267.104.518.292.706a.992.992 0 0 0 .706.294h.001a.99.99 0 0 0 .707-.294l6.217-6.218-1.413-1.414z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M11.227 17.549a.502.502 0 0 1-.354-.146l-4.24-4.242a.5.5 0 0 1 .707-.707l4.24 4.242a.5.5 0 0 1-.353.853z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M8.744 14.584L19.431 3.897l.707.707L9.451 15.291z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M20.969 6c-.132 0-.259-.086-.354-.18L18.14 3.33a.52.52 0 0 1-.145-.406.504.504 0 0 1 .213-.37L21.749.092a.499.499 0 0 1 .639.056l1.5 1.499a.5.5 0 0 1 .047.653l-2.566 3.467c-.087.116-.22.233-.364.233h-.036zm-1.698-2.971l1.643 1.642 1.961-2.623-.898-.898-2.706 1.879zM9.45 12.27L5.933 8.734c-1.605.537-3.384.117-4.617-1.117C.022 6.323-.364 4.31.356 2.608a.498.498 0 0 1 .778-.191L3.06 4H4v-.891L2.43 1.137a.5.5 0 0 1 .197-.773C4.32-.35 6.397.045 7.68 1.325a4.478 4.478 0 0 1 1.082 4.618l3.517 3.516-.707.707-3.746-3.744a.501.501 0 0 1-.107-.549 3.486 3.486 0 0 0-.747-3.841C6.129 1.19 4.846.841 3.666 1.084l1.225 1.539c.07.089.109.198.109.312V4.5a.5.5 0 0 1-.5.5H2.881a.5.5 0 0 1-.318-.114L1.071 3.659c-.241 1.164.107 2.405.952 3.251 1.027 1.028 2.534 1.333 3.84.782a.496.496 0 0 1 .55.108l3.746 3.765-.709.705zm9.766 11.589c-1.108 0-2.179-.449-3.044-1.313a4.48 4.48 0 0 1-1.082-4.618l-3.519-3.52.707-.707 3.747 3.748a.5.5 0 0 1 .107.549 3.487 3.487 0 0 0 .747 3.841c.82.818 1.837 1.16 2.876.975l-1.6-1.516a.503.503 0 0 1-.155-.363V18.5a.5.5 0 0 1 .5-.5h2.381c.135 0 .264.055.358.15l1.561 1.599c.185-1.069-.159-2.156-.972-2.969-.99-.991-2.498-1.263-3.84-.693a.502.502 0 0 1-.548-.105l-3.745-3.72.705-.709 3.516 3.492c1.636-.559 3.417-.174 4.619 1.028 1.302 1.301 1.67 3.15.96 4.828a.5.5 0 0 1-.819.154L20.67 19H19v1.72l2.069 1.961a.501.501 0 0 1-.149.824 4.389 4.389 0 0 1-1.704.354z"
    }
  }],
  title: "preferences"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "circle",
    attrs: {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: "10",
      cx: "2.5",
      cy: "3.5",
      r: "2"
    }
  }, {
    name: "circle",
    attrs: {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: "10",
      cx: "21.5",
      cy: "3.5",
      r: "2"
    }
  }, {
    name: "circle",
    attrs: {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: "10",
      cx: "11.5",
      cy: "21.5",
      r: "2"
    }
  }, {
    name: "path",
    attrs: {
      d: "M15.5 3.5h-8m5.7 2.2l2.3-2.2v-.1l-2.3-2.2m2.6 14.4l3.8-7.2m-4.7 4.1l.9 3.1 3.1-.9m-14-5.5l4 7M8 10l-3.1-.8-.9 3.1",
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: "10"
    }
  }],
  title: "program-management"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M3.919 8h-.838A2.084 2.084 0 0 1 1 5.919v-.838C1 3.934 1.934 3 3.081 3h.838C5.066 3 6 3.934 6 5.081v.838A2.084 2.084 0 0 1 3.919 8zm-.838-4C2.485 4 2 4.485 2 5.081v.838C2 6.515 2.485 7 3.081 7h.838C4.515 7 5 6.515 5 5.919v-.838C5 4.485 4.515 4 3.919 4h-.838zm.838 11h-.838A2.084 2.084 0 0 1 1 12.919v-.838C1 10.934 1.934 10 3.081 10h.838C5.066 10 6 10.934 6 12.081v.838A2.084 2.084 0 0 1 3.919 15zm-.838-4C2.485 11 2 11.485 2 12.081v.838C2 13.515 2.485 14 3.081 14h.838C4.515 14 5 13.515 5 12.919v-.838C5 11.485 4.515 11 3.919 11h-.838zm.838 11h-.838A2.084 2.084 0 0 1 1 19.919v-.838C1 17.934 1.934 17 3.081 17h.838C5.066 17 6 17.934 6 19.081v.838A2.084 2.084 0 0 1 3.919 22zm-.838-4C2.485 18 2 18.485 2 19.081v.838C2 20.515 2.485 21 3.081 21h.838C4.515 21 5 20.515 5 19.919v-.838C5 18.485 4.515 18 3.919 18h-.838zM21.919 8H10.081A2.084 2.084 0 0 1 8 5.919v-.838C8 3.934 8.934 3 10.081 3h11.838C23.066 3 24 3.934 24 5.081v.838A2.084 2.084 0 0 1 21.919 8zM10.081 4C9.485 4 9 4.485 9 5.081v.838C9 6.515 9.485 7 10.081 7h11.838C22.515 7 23 6.515 23 5.919v-.838C23 4.485 22.515 4 21.919 4H10.081zm11.838 11H10.081A2.084 2.084 0 0 1 8 12.919v-.838C8 10.934 8.934 10 10.081 10h11.838c1.147 0 2.081.934 2.081 2.081v.838A2.084 2.084 0 0 1 21.919 15zm-11.838-4C9.485 11 9 11.485 9 12.081v.838C9 13.515 9.485 14 10.081 14h11.838c.596 0 1.081-.485 1.081-1.081v-.838c0-.596-.485-1.081-1.081-1.081H10.081zm11.838 11H10.081A2.084 2.084 0 0 1 8 19.919v-.838C8 17.934 8.934 17 10.081 17h11.838c1.147 0 2.081.934 2.081 2.081v.838A2.084 2.084 0 0 1 21.919 22zm-11.838-4C9.485 18 9 18.485 9 19.081v.838C9 20.515 9.485 21 10.081 21h11.838c.596 0 1.081-.485 1.081-1.081v-.838c0-.596-.485-1.081-1.081-1.081H10.081z"
    }
  }],
  title: "projects"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M9.896 10.518a.502.502 0 0 1-.476-.347C9.409 10.139 8.365 7 5.757 7H1a.5.5 0 0 1 0-1h4.757c3.342 0 4.564 3.708 4.615 3.865a.5.5 0 0 1-.476.653z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M5.757 18H1a.5.5 0 0 1 0-1h4.757c2.239 0 3.953-2.679 5.61-5.27C13.169 8.913 15.033 6 17.819 6H23a.5.5 0 0 1 0 1h-5.181c-2.239 0-3.952 2.679-5.609 5.27C10.408 15.087 8.544 18 5.757 18z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M23 18h-5.181c-3.233 0-5.509-3.091-5.604-3.223a.5.5 0 0 1 .809-.587c.02.028 2.077 2.81 4.794 2.81H23a.5.5 0 0 1 0 1zm-1.664-7.97a.5.5 0 0 1-.416-.777l1.825-2.737-1.825-2.738a.5.5 0 1 1 .832-.554l2.01 3.016a.5.5 0 0 1 0 .555l-2.01 3.015a.5.5 0 0 1-.416.22z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M21.336 21.087a.5.5 0 0 1-.416-.777l1.825-2.738-1.825-2.737a.5.5 0 1 1 .832-.554l2.01 3.015a.5.5 0 0 1 0 .555l-2.01 3.016a.5.5 0 0 1-.416.22z"
    }
  }],
  title: "redirect"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M10 22H6.905C3.227 22 0 18.495 0 14.5S3.227 7 6.905 7H23a.5.5 0 0 1 0 1H6.905C3.814 8 1 11.098 1 14.5S3.814 21 6.905 21H10a.5.5 0 0 1 0 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M18.573 12.854a.5.5 0 0 1-.354-.853l4.531-4.532-4.489-3.578c-.216-.172-.252-.486-.079-.702s.488-.253.702-.079l4.927 3.927a.5.5 0 0 1 .042.744l-4.927 4.928a.497.497 0 0 1-.353.145z"
    }
  }],
  title: "redo"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M10.516 22c3.552 0 6.809-1.755 8.772-4.75a.5.5 0 0 0-.836-.548c-1.845 2.813-4.971 4.431-8.301 4.292-5.234-.191-9.337-4.607-9.145-9.843.192-5.234 4.595-9.348 9.844-9.144a9.602 9.602 0 0 1 6.934 3.351c1.516 1.774 2.302 4.031 2.265 6.447L17.192 8.54a.5.5 0 1 0-.752.658l3.684 4.21a.496.496 0 0 0 .408.17.503.503 0 0 0 .384-.222l3.158-4.736a.5.5 0 1 0-.832-.554l-2.194 3.291c-.061-2.485-.924-4.8-2.502-6.648a10.612 10.612 0 0 0-7.657-3.701C5.086.794.222 5.328.007 11.113c-.212 5.787 4.322 10.668 10.107 10.88.135.005.269.007.402.007z"
    }
  }],
  title: "refresh"
}, {
  name: "svg",
  attrs: {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M21.5 22h-19c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h19c.3 0 .5.2.5.5s-.2.5-.5.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M5.8 22H3.3c-.3 0-.5-.2-.5-.5v-4.1c0-.3.2-.5.5-.5h2.5c.3 0 .5.2.5.5v4.1c0 .3-.2.5-.5.5zm-2-1h1.5v-3.1H3.8V21zm7 1H8.3c-.3 0-.5-.2-.5-.5v-8.3c0-.3.2-.5.5-.5h2.5c.3 0 .5.2.5.5v8.3c0 .3-.3.5-.5.5zm-2-1h1.5v-7.3H8.8V21zm6.9 1h-2.5c-.3 0-.5-.2-.5-.5v-6.6c0-.3.2-.5.5-.5h2.5c.3 0 .5.2.5.5v6.6c0 .3-.2.5-.5.5zm-2-1h1.5v-5.6h-1.5V21zm7 1h-2.5c-.3 0-.5-.2-.5-.5V9.1c0-.3.2-.5.5-.5h2.5c.3 0 .5.2.5.5v12.4c0 .3-.2.5-.5.5zm-2-1h1.5V9.6h-1.5V21zM4.6 12.9c-.7 0-1.3-.6-1.3-1.3s.6-1.3 1.3-1.3 1.3.6 1.3 1.3-.6 1.3-1.3 1.3zm0-1.6c-.2 0-.3.1-.3.3s.1.3.3.3.3-.1.3-.3-.2-.3-.3-.3zm4.9-2.5c-.7 0-1.3-.6-1.3-1.3s.6-1.3 1.3-1.3 1.3.6 1.3 1.3-.5 1.3-1.3 1.3zm0-1.7c-.2 0-.3.1-.3.3s.1.3.3.3.3-.1.3-.3-.1-.3-.3-.3zm5 3.3c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3s1.3.6 1.3 1.3c0 .7-.6 1.3-1.3 1.3zm0-1.6c-.2 0-.3.1-.3.3s.1.3.3.3.3-.1.3-.3-.1-.3-.3-.3zm4.9-4.1c-.7 0-1.3-.6-1.3-1.3S18.7 2 19.4 2s1.3.6 1.3 1.3-.5 1.4-1.3 1.4zm0-1.7c-.2 0-.3.1-.3.3s.1.3.3.3.3-.1.3-.3-.1-.3-.3-.3z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M5.2 11.6c-.1 0-.3-.1-.4-.2-.2-.2-.2-.5.1-.7l3.6-3.1c.2-.2.5-.2.7.1.2.2.2.5-.1.7l-3.6 3.1c0 .1-.2.1-.3.1zm8.5-2.2h-.2L10 8.2c-.2-.1-.3-.4-.2-.7.1-.3.4-.4.6-.3l3.5 1.2c.3.1.4.4.3.6-.1.2-.3.4-.5.4zm1.4-.5c-.1 0-.2 0-.3-.1-.2-.2-.2-.5-.1-.7l3.8-4.5c.2-.2.5-.2.7-.1.2.2.2.5.1.7l-3.8 4.5c-.2.2-.3.2-.4.2z"
    }
  }],
  title: "results"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M18 10H7c-1.93 0-3.5-1.57-3.5-3.5S5.07 3 7 3h11c1.93 0 3.5 1.57 3.5 3.5S19.93 10 18 10zM7 4C5.622 4 4.5 5.121 4.5 6.5S5.622 9 7 9h11c1.378 0 2.5-1.121 2.5-2.5S19.378 4 18 4H7zm11 17H7c-1.93 0-3.5-1.57-3.5-3.5S5.07 14 7 14h11c1.93 0 3.5 1.57 3.5 3.5S19.93 21 18 21zM7 15c-1.378 0-2.5 1.121-2.5 2.5S5.622 20 7 20h11c1.378 0 2.5-1.121 2.5-2.5S19.378 15 18 15H7z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M7 10c-1.93 0-3.5-1.57-3.5-3.5S5.07 3 7 3s3.5 1.57 3.5 3.5S8.93 10 7 10zm0-6C5.622 4 4.5 5.121 4.5 6.5S5.622 9 7 9s2.5-1.121 2.5-2.5S8.378 4 7 4zm11 17c-1.93 0-3.5-1.57-3.5-3.5S16.07 14 18 14s3.5 1.57 3.5 3.5S19.93 21 18 21zm0-6c-1.378 0-2.5 1.121-2.5 2.5S16.622 20 18 20s2.5-1.121 2.5-2.5S19.378 15 18 15z"
    }
  }],
  title: "rollouts"
}, {
  name: "svg",
  attrs: {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      "class": "st0",
      d: "M1.7 16.9h20.9"
    }
  }, {
    name: "path",
    attrs: {
      "class": "st1",
      d: "M1 11.7l21.9-7.4h.2c.1 0 .1 0 .2.1h.1v7.3s-.1.1-.2.1h-22c-.1-.1-.1-.1-.2-.1zm22.4-.1z"
    }
  }, {
    name: "path",
    attrs: {
      "class": "st2",
      d: "M8.4 16.9c0 1.2-1 2.2-2.2 2.2S4 18.1 4 16.9s1-2.2 2.2-2.2 2.2 1 2.2 2.2z"
    }
  }],
  title: "ruleset"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M9.5 16a.502.502 0 0 1-.354-.146l-2.5-2.5a.5.5 0 0 1 .707-.707l2.159 2.158 7.146-6.67a.5.5 0 0 1 .683.73l-7.5 7A.496.496 0 0 1 9.5 16z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-23C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1z"
    }
  }],
  title: "save"
}, {
  name: "svg",
  attrs: {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      "class": "cls-1",
      d: "M21.33 9.67A2.34 2.34 0 1 0 19 7.33a2.34 2.34 0 0 0 2.33 2.34zM2.67 11.42A2.33 2.33 0 1 0 5 13.75a2.33 2.33 0 0 0-2.33-2.33zm16.39-1.36l-.7-.93-1.75 1.31.7.93zm2.27 6.61a2.33 2.33 0 0 0-1.39.47L16.44 15a4 4 0 0 0 .23-1.29 4.09 4.09 0 0 0-4.09-4.09 3.8 3.8 0 0 0-.89.11l-1.48-3.15a2.33 2.33 0 1 0-1.71.75h.12l1.49 3.2a4.07 4.07 0 1 0 5.43 6L19 18.64a2.2 2.2 0 0 0 0 .36 2.34 2.34 0 1 0 2.33-2.33zm-8.75-1.17a1.75 1.75 0 1 1 1.75-1.75 1.75 1.75 0 0 1-1.75 1.75zm-6.71-1.17h1.75v-1.16H5.87z"
    }
  }],
  title: "sdk-agent"
}, {
  name: "svg",
  attrs: {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      "class": "cls-1",
      d: "M17.48 14.34a1 1 0 1 1 1-1 1 1 0 0 1-1 1m-10.93 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1m11.28-5.95l2-3.42a.42.42 0 0 0-.12-.57.41.41 0 0 0-.57.11L17.09 8A12.39 12.39 0 0 0 6.94 8l-2-3.46a.41.41 0 0 0-.74.36l2 3.42a11.66 11.66 0 0 0-6 9.33h23.68a11.66 11.66 0 0 0-6.05-9.33"
    }
  }],
  title: "sdk-android"
}, {
  name: "svg",
  attrs: {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      "class": "cls-1",
      d: "M18.87 11.61h.84v.84h-.84zm3.64-4.46V7.1v9.74a2.08 2.08 0 0 1-.25 1 1.94 1.94 0 0 1-.77.76l-8.4 4.84a2 2 0 0 1-2.23 0c-1.05-.65-6.66-3.85-8.33-4.82a1.94 1.94 0 0 1-.77-.76 2.05 2.05 0 0 1-.25-1V7.13a2 2 0 0 1 1-1.79c1.64-1 7.21-4.17 8.33-4.82a2 2 0 0 1 2.23 0l8.4 4.85a2 2 0 0 1 .76.74 2.17 2.17 0 0 1 .28 1.04zm-4.44 8.33l-3-1.76a3.47 3.47 0 1 1 0-3.45l3-1.75a7 7 0 1 0 0 7zM21 10.92h-.6v-.56h-.69v.56h-.84v-.56h-.69v.56h-.56v.69h.56v.84h-.57v.69h.57v.57h.69v-.57h.84v.57h.69v-.57h.6v-.69h-.6v-.84h.6z"
    }
  }],
  title: "sdk-csharp"
}, {
  name: "svg",
  attrs: {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      "class": "cls-1",
      d: "M15.9 12a1.79 1.79 0 0 1-1.53-.86L12 7.21l-2.37 3.93a1.78 1.78 0 0 1-1.52.86 1.57 1.57 0 0 1-.49-.07l-5.05-1.44v6.56a1.18 1.18 0 0 0 .89 1.14l8 2a2.44 2.44 0 0 0 1.14 0l8-2a1.17 1.17 0 0 0 .89-1.14v-6.56l-5 1.44a1.66 1.66 0 0 1-.59.07zm7.83-4.13l-1.9-3.79a.6.6 0 0 0-.61-.33L12 4.93l3.38 5.6a.61.61 0 0 0 .68.27l7.29-2.08a.6.6 0 0 0 .38-.85zM2.17 4.08L.27 7.87a.59.59 0 0 0 .37.84l7.3 2.09a.61.61 0 0 0 .68-.27L12 4.93 2.78 3.75a.6.6 0 0 0-.61.33z"
    }
  }],
  title: "sdk-generic"
}, {
  name: "svg",
  attrs: {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      "class": "cls-1",
      d: "M1.91 9.92l.18-.35c0-.06.06-.06.12-.06h4.1a.06.06 0 0 1 .06.06l-.18.3c0 .05-.06.05-.12.05zM.18 10.94l.18-.36c0-.06.06-.06.12-.06h5.23a.06.06 0 0 1 .06.06l-.12.3c0 .06-.06.06-.12.06zM3 12a.06.06 0 0 1-.08 0l.18-.3c0-.06.06-.06.12-.06h2.31a.06.06 0 0 1 .06.06v.3a.06.06 0 0 1-.06.06zm11.93-2.31c-.72.18-1.19.29-1.9.53-.18.06-.18.06-.36-.12a1.84 1.84 0 0 0-.54-.41 2 2 0 0 0-2.08.18 2.53 2.53 0 0 0-1.19 2.19 1.8 1.8 0 0 0 1.55 1.79 2.11 2.11 0 0 0 2-.77 2.54 2.54 0 0 0 .3-.42h-2.2c-.24 0-.3-.18-.24-.36.18-.35.42-1 .6-1.25.06-.06.11-.17.29-.17h4.17a5.44 5.44 0 0 1-.06.95 4.52 4.52 0 0 1-1 2.26 4.85 4.85 0 0 1-3.27 2 3.84 3.84 0 0 1-3.09-.77 3.9 3.9 0 0 1-1.48-2.56 4.61 4.61 0 0 1 1-3.39 5.1 5.1 0 0 1 3.21-2 4.14 4.14 0 0 1 3 .53 3.47 3.47 0 0 1 1.31 1.61c.16.12.1.18-.02.18z"
    }
  }, {
    name: "path",
    attrs: {
      "class": "cls-1",
      d: "M18.73 16.05a4 4 0 0 1-2.79-1 3.65 3.65 0 0 1-1.25-2.2 4.47 4.47 0 0 1 1-3.45 4.62 4.62 0 0 1 3.21-1.9 4.22 4.22 0 0 1 3.27.59 3.55 3.55 0 0 1 1.61 2.56 4.58 4.58 0 0 1-1.31 3.92 5.44 5.44 0 0 1-2.74 1.49 5 5 0 0 0-1-.01zm2.74-4.64a.65.65 0 0 0-.06-.36 1.89 1.89 0 0 0-2.32-1.54 2.46 2.46 0 0 0-2 2 2 2 0 0 0 1.07 2.2 2.12 2.12 0 0 0 1.9-.06 2.8 2.8 0 0 0 1.41-2.24z"
    }
  }],
  title: "sdk-go"
}, {
  name: "svg",
  attrs: {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      "class": "cls-1",
      d: "M15.65 14.57a8.2 8.2 0 0 1 1.07-.57s-1.77.32-3.53.47a32.79 32.79 0 0 1-5.65.06c-2.75-.37 1.52-1.38 1.52-1.38a8.14 8.14 0 0 0-3.7.87c-2.36 1.16 5.96 1.7 10.29.55zm-3.91-1.47c-.87-1.95-3.81-3.67 0-6.68C16.49 2.67 14.05.23 14.05.23 15 4.11 10.59 5.28 9 7.69c-1.12 1.64.51 3.41 2.74 5.41zM17 5s-8 2-4.2 6.45a1.72 1.72 0 0 1-.3 2.48s2.87-1.49 1.55-3.34S11.87 8 17 5zm-.28 12.39l-.09.12c5.88-1.54 3.71-5.44.91-4.46a.79.79 0 0 0-.38.29 2.83 2.83 0 0 1 .5-.13c1.42-.3 3.46 1.9-.94 4.18zm2.16 2.86s.67.55-.73 1c-2.65.8-11 1.05-13.36 0-.84-.36.73-.87 1.23-1a3.24 3.24 0 0 1 .81-.09c-.93-.66-6 1.28-2.59 1.84 9.35 1.58 17.06-.62 14.63-1.72zM8.63 18.38c-3.61 1 2.19 3.09 6.78 1.13a8.6 8.6 0 0 1-1.29-.64 13.44 13.44 0 0 1-4.86.21c-1.53-.17-.63-.7-.63-.7zm8.24 4.46a34.58 34.58 0 0 1-10.7.16s.54.45 3.32.63c4.23.27 10.72-.16 10.87-2.15 0 0-.3.75-3.49 1.36zm-2-6.43a18.9 18.9 0 0 1-6.27.3c-1.54-.16-.53-.9-.53-.9-4 1.32 2.21 2.82 7.76 1.19a2.9 2.9 0 0 1-.96-.59z"
    }
  }],
  title: "sdk-java"
}, {
  name: "svg",
  attrs: {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      "class": "cls-1",
      d: "M1.1 1.1v21.8h21.8V1.1zm11.9 17a2.78 2.78 0 0 1-3.1 3.09 3.19 3.19 0 0 1-3.07-1.87l1.67-1c.32.57.61 1.05 1.32 1.05s1.1-.26 1.1-1.29v-7h2v7zm4.85 3.09a3.94 3.94 0 0 1-3.73-2.09l1.67-1a2.22 2.22 0 0 0 2 1.25c.85 0 1.4-.42 1.4-1s-.56-.95-1.5-1.36l-.51-.22c-1.48-.63-2.46-1.42-2.46-3.09a2.74 2.74 0 0 1 3-2.71 3 3 0 0 1 2.91 1.64l-1.6 1a1.4 1.4 0 0 0-1.31-.87.89.89 0 0 0-1 .87c0 .62.38.86 1.26 1.25l.51.22c1.74.74 2.72 1.51 2.72 3.22s-1.45 2.85-3.39 2.85z"
    }
  }],
  title: "sdk-javascript"
}, {
  name: "svg",
  attrs: {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      "class": "cls-1",
      d: "M11.85 19.86a.46.46 0 0 1-.22-.06l-.71-.42c-.1-.06-.05-.08 0-.09a1.3 1.3 0 0 0 .32-.15h.06l.54.33a.09.09 0 0 0 .07 0L14 18.24a.07.07 0 0 0 0-.06v-2.45a.05.05 0 0 0 0-.06l-2.12-1.23h-.07l-2.12 1.23a.06.06 0 0 0 0 .06v2.51l.59.33c.31.16.51 0 .51-.21v-2.43a.06.06 0 0 1 .06-.06h.27a.06.06 0 0 1 .06.06v2.43a.59.59 0 0 1-.63.66.93.93 0 0 1-.49-.13l-.56-.32a.47.47 0 0 1-.22-.39v-2.45a.44.44 0 0 1 .22-.39l2.13-1.23a.43.43 0 0 1 .44 0l2.13 1.23a.45.45 0 0 1 .23.39v2.45a.45.45 0 0 1-.23.39l-2.13 1.23a.4.4 0 0 1-.22.06zm1.72-2.42c0-.46-.31-.58-1-.67s-.73-.13-.73-.29 0-.3.54-.3.6.1.67.39a.06.06 0 0 0 .06.05h.32v-.05c0-.5-.38-.74-1.06-.74s-1 .26-1 .69.36.59.94.65.75.17.75.3-.19.34-.64.34-.69-.14-.73-.42a.06.06 0 0 0-.06-.05h-.28a.06.06 0 0 0-.06.06c0 .36.19.79 1.12.79.69 0 1.07-.27 1.07-.73zm2-1.85a.41.41 0 0 1-.41.41.41.41 0 1 1 0-.81.4.4 0 0 1 .42.4zm-.07 0a.34.34 0 0 0-.35-.34.35.35 0 0 0 0 .69.35.35 0 0 0 .36-.35zm-.16.23h-.1v-.14h-.14v.18H15v-.46h.16c.06 0 .16 0 .16.12a.11.11 0 0 1-.08.12c.06 0 .06 0 .07.1s0 .1 0 .12zm-.11-.32c0-.06 0-.06-.06-.06h-.07v.12h.07c.06 0 .07-.04.07-.06zm-10-5.24a.27.27 0 0 0-.1-.26L2.88 8.72a.28.28 0 0 0-.13 0h-.13L.35 10a.28.28 0 0 0-.13.24v3.49a.15.15 0 0 0 .07.12.15.15 0 0 0 .13 0l1.34-.77a.27.27 0 0 0 .14-.24v-1.61A.26.26 0 0 1 2 11l.57-.33a.25.25 0 0 1 .14 0 .23.23 0 0 1 .14 0l.57.33a.26.26 0 0 1 .13.23v1.63a.27.27 0 0 0 .14.24l1.34.77a.15.15 0 0 0 .13 0 .12.12 0 0 0 .07-.12v-3.49zM17.6 6.44v6.49a.27.27 0 0 1-.14.24l-2.25 1.3a.26.26 0 0 1-.27 0l-2.26-1.3a.28.28 0 0 1-.13-.24v-2.6a.28.28 0 0 1 .13-.24l2.26-1.3a.26.26 0 0 1 .27 0l.56.32a.1.1 0 0 0 .15-.11V5.57a.13.13 0 0 1 .2-.11l1.34.75a.24.24 0 0 1 .14.23zm-1.69 4.74v-.06l-.77-.44h-.07l-.77.44a.09.09 0 0 0 0 .06v.9a.07.07 0 0 0 0 .06l.77.44h.07l.77-.44a.07.07 0 0 0 0-.06v-.9zm7.72 0a.28.28 0 0 0 .13-.24v-.63a.28.28 0 0 0-.13-.23l-2.24-1.3a.28.28 0 0 0-.28 0l-2.25 1.3a.27.27 0 0 0-.14.23v2.59a.24.24 0 0 0 .14.23l2.24 1.28a.26.26 0 0 0 .27 0l1.35-.75a.14.14 0 0 0 0-.24l-2.27-1.3a.15.15 0 0 1-.07-.12v-.82a.14.14 0 0 1 .07-.11l.71-.41a.11.11 0 0 1 .13 0l.71.41a.14.14 0 0 1 .07.11v.64a.14.14 0 0 0 .21.12l1.35-.78zm-2.85.13v.5l.44.26h.05l.43-.26v-.5l-.43-.31h-.05zm-9.35 1.6V10.3a.29.29 0 0 0-.14-.24L9 8.77a.24.24 0 0 0-.27 0l-2.21 1.29a.27.27 0 0 0-.14.24v2.59a.28.28 0 0 0 .14.23l2.25 1.3a.31.31 0 0 0 .28 0l2.24-1.3a.25.25 0 0 0 .13-.17.13.13 0 0 0 0-.06zM8.7 8.29zm2.8 4.79z"
    }
  }],
  title: "sdk-javascript-node"
}, {
  name: "svg",
  attrs: {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      "class": "cls-1",
      d: "M18.94 14.38a9.78 9.78 0 0 1-.94 1.68 8 8 0 0 1-1.21 1.45 2.27 2.27 0 0 1-1.54.69 3.94 3.94 0 0 1-1.43-.34 4.06 4.06 0 0 0-1.54-.34 4.31 4.31 0 0 0-1.58.34 4.15 4.15 0 0 1-1.37.36 2.21 2.21 0 0 1-1.59-.7A8.48 8.48 0 0 1 6.5 16a10.14 10.14 0 0 1-1.33-2.65 10 10 0 0 1-.57-3.15 5.91 5.91 0 0 1 .77-3A4.51 4.51 0 0 1 7 5.56 4.28 4.28 0 0 1 9.11 5a5 5 0 0 1 1.66.38 5 5 0 0 0 1.32.39 8.22 8.22 0 0 0 1.46-.45 4.85 4.85 0 0 1 2-.36 4.17 4.17 0 0 1 3.25 1.76 3.84 3.84 0 0 0-.8 6.06 4.08 4.08 0 0 0 1.21.77 8.21 8.21 0 0 1-.31.77zM15.58 1.15a3.79 3.79 0 0 1-1 2.44 3.27 3.27 0 0 1-2.69 1.33 1.82 1.82 0 0 1 0-.33 3.89 3.89 0 0 1 1-2.47 4 4 0 0 1 1.24-.92 3.77 3.77 0 0 1 1.43-.4 2 2 0 0 1 0 .35zM3.81 20.76a1.46 1.46 0 0 1-1.47 1.66 1.46 1.46 0 0 1-1.48-1.66 1.47 1.47 0 0 1 1.48-1.66 1.46 1.46 0 0 1 1.47 1.66zm-2.45 0c0 .73.37 1.2 1 1.2s1-.47 1-1.2-.37-1.2-1-1.2-1 .44-1 1.2zM4.6 22v.38h-.49V19h.47v1.31a.8.8 0 0 1 .73-.42c.61 0 1 .48 1 1.24s-.38 1.23-1 1.23A.82.82 0 0 1 4.6 22zm0-.82c0 .5.25.81.65.81s.64-.3.64-.81-.24-.81-.64-.81-.68.28-.68.78zm2.48 1.29c0 .49-.25.72-.77.72h-.14v-.39h.07c.25 0 .34-.1.34-.33V20h.47zm-.54-3.19a.31.31 0 0 1 .61 0 .28.28 0 0 1-.3.28.29.29 0 0 1-.34-.31zm2.89 2.42a1 1 0 0 1-1 .69 1.08 1.08 0 0 1-1.1-1.23 1.1 1.1 0 0 1 1.1-1.25c.67 0 1.07.45 1.07 1.2v.17H7.77a.64.64 0 0 0 .64.69.58.58 0 0 0 .59-.27zm-1.66-.77H9a.58.58 0 0 0-.59-.62.61.61 0 0 0-.64.62zm3.49-.19a.54.54 0 0 0-.57-.41c-.39 0-.64.3-.64.81s.25.83.64.83a.53.53 0 0 0 .57-.39h.46a1 1 0 0 1-1 .81 1.1 1.1 0 0 1-1.12-1.25 1.09 1.09 0 0 1 1.12-1.23 1 1 0 0 1 1 .83zm1.33-1.38V20h.52v.4h-.52v1.23c0 .25.1.36.34.36h.18v.39a1.09 1.09 0 0 1-.26 0c-.52 0-.73-.19-.73-.65v-1.37h-.38V20h.38v-.6zm.68-.11a.31.31 0 1 1 .3.28.29.29 0 0 1-.3-.28zm.07.7h.47v2.4h-.47zm2 2.4h-.51L14 20h.5l.6 1.89.6-1.89h.5zm2.93-.65a1 1 0 0 1-1 .69 1.08 1.08 0 0 1-1.1-1.23 1.1 1.1 0 0 1 1.1-1.25c.67 0 1.07.45 1.07 1.2v.17H16.6a.64.64 0 0 0 .64.69.58.58 0 0 0 .57-.29zm-1.66-.77h1.21a.58.58 0 0 0-.59-.62.61.61 0 0 0-.63.62zm1.93.37v-.46H20v.46zm1.72-.54c0-1 .55-1.66 1.43-1.66A1.27 1.27 0 0 1 23 20.2h-.49a.83.83 0 0 0-.83-.64c-.57 0-.93.46-.93 1.2s.36 1.2.93 1.2a.8.8 0 0 0 .83-.58H23a1.24 1.24 0 0 1-1.32 1c-.88.04-1.43-.59-1.43-1.62z"
    }
  }],
  title: "sdk-objectivec"
}, {
  name: "svg",
  attrs: {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      "class": "cls-1",
      d: "M12 6.42c6.35 0 11.23 2.68 11.23 5.62s-4.9 5.61-11.23 5.61S.76 15 .76 12 5.64 6.42 12 6.42m0-.62C5.45 5.8.14 8.59.14 12S5.45 18.27 12 18.27 23.84 15.48 23.84 12 18.53 5.8 12 5.8zm-3.78 5.74c-.29 1.5-1.33 1.34-2.6 1.34l.51-2.62c1.41 0 2.36-.15 2.09 1.28zm-4.47 4H5.1l.33-1.66c1.52 0 2.46.11 3.34-.71A2.55 2.55 0 0 0 9.3 9.9a2.16 2.16 0 0 0-1.73-.62H5zm6.87-7.91H12l-.32 1.66c1.17 0 2.25-.09 2.77.39s.29 1.15-.31 4.19h-1.4c.57-2.94.68-3.18.47-3.41s-.65-.17-1.75-.17l-.7 3.58H9.41l1.21-6.24zm8.22 3.92c-.3 1.52-1.36 1.34-2.6 1.34l.51-2.62c1.42 0 2.36-.15 2.09 1.28zm-4.47 4h1.36l.32-1.66c1.6 0 2.49.09 3.34-.71a2.53 2.53 0 0 0 .53-3.26 2.15 2.15 0 0 0-1.72-.62h-2.62z"
    }
  }],
  title: "sdk-php"
}, {
  name: "svg",
  attrs: {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      "class": "cls-1",
      d: "M23.35 9.08c-.41-1.62-1.17-2.85-2.81-2.85h-2.11v2.49a3.61 3.61 0 0 1-3.51 3.57H9.3a2.87 2.87 0 0 0-2.81 2.85v5.36c0 1.52 1.33 2.42 2.81 2.85a9.43 9.43 0 0 0 5.62 0c1.41-.41 2.81-1.23 2.81-2.85v-2.14h-5.61v-.72h8.42c1.64 0 2.24-1.14 2.81-2.85a9.63 9.63 0 0 0 0-5.71zm-8.08 10.7a1.07 1.07 0 1 1-1.06 1.07 1.07 1.07 0 0 1 1.06-1.07zM9 11.58h5.62a2.83 2.83 0 0 0 2.81-2.85V3.37A3.12 3.12 0 0 0 14.66.45 17.36 17.36 0 0 0 9 .45c-2.37.42-2.8 1.3-2.8 2.92v2.15h5.62v.71H4.13A3.51 3.51 0 0 0 .61 9.08a10.64 10.64 0 0 0 0 5.71c.4 1.66 1.36 2.85 3 2.85h1.92v-2.56A3.58 3.58 0 0 1 9 11.58zm-.35-7.5A1.06 1.06 0 0 1 7.63 3a1.06 1.06 0 1 1 2.12 0 1.05 1.05 0 0 1-1.06 1.08z"
    }
  }],
  title: "sdk-python"
}, {
  name: "svg",
  attrs: {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      "class": "cls-1",
      d: "M19.47 8.47l-.75-.23.12-.51C19.4 5 19 2.79 17.78 2.06s-3.18 0-5.18 1.77c-.19.17-.39.35-.57.53L11.65 4C9.56 2.15 7.47 1.37 6.21 2.1s-1.56 2.76-1 5.36c0 .25.1.5.16.76-.29.08-.58.18-.85.27C2 9.34.26 10.68.26 12.07s1.87 2.87 4.42 3.74l.63.2c-.07.28-.13.55-.19.83-.48 2.55-.1 4.57 1.1 5.26s3.33 0 5.36-1.79c.16-.15.32-.29.48-.45.2.2.41.39.62.57 2 1.69 3.91 2.37 5.11 1.68s1.64-2.89 1.12-5.53c0-.21-.09-.41-.14-.62l.43-.14c2.65-.87 4.57-2.29 4.57-3.75s-1.77-2.74-4.3-3.6zm-6.22-3.9c1.71-1.49 3.3-2.07 4-1.65s1.07 2.24.59 4.61c0 .15-.07.31-.11.46a23.1 23.1 0 0 0-3.09-.49 24.06 24.06 0 0 0-2-2.44zm-5.31 9.88c.23.4.47.8.72 1.19a19.65 19.65 0 0 1-2.13-.34 21.25 21.25 0 0 1 .75-2c.21.4.43.8.66 1.19zM6.55 8.93a21.12 21.12 0 0 1 2.09-.36c-.24.38-.48.77-.71 1.17s-.44.79-.65 1.19a20.35 20.35 0 0 1-.73-2zm1.25 3.16q.46-.94 1-1.86c.35-.61.72-1.2 1.12-1.79.69 0 1.39-.08 2.11-.08s1.42 0 2.1.08c.39.58.77 1.17 1.12 1.78s.68 1.23 1 1.86c-.31.63-.64 1.25-1 1.87s-.72 1.2-1.11 1.79c-.68 0-1.39.07-2.11.07s-1.42 0-2.1-.06c-.4-.58-.77-1.18-1.13-1.79s-.68-1.23-1-1.87zm8.3 2.35c.23-.4.45-.81.67-1.22.29.66.55 1.34.78 2a20.32 20.32 0 0 1-2.16.37c.25-.39.48-.78.71-1.18zm.66-3.51c-.22-.4-.44-.81-.67-1.2s-.45-.78-.7-1.16a21 21 0 0 1 2.11.37 19.77 19.77 0 0 1-.74 1.99zM12 5.77a19.27 19.27 0 0 1 1.35 1.64h-2.73c.48-.59.95-1.14 1.38-1.64zM6.7 3c.77-.45 2.48.19 4.29 1.79l.35.32a22.85 22.85 0 0 0-2 2.44A23.08 23.08 0 0 0 6.28 8c-.06-.24-.11-.47-.16-.71C5.69 5 6 3.37 6.7 3zM5.57 15.06L5 14.88a9.43 9.43 0 0 1-2.89-1.44 2 2 0 0 1-.86-1.37c0-.84 1.45-1.91 3.54-2.64.26-.1.53-.18.8-.26a24.44 24.44 0 0 0 1.12 2.92 26 26 0 0 0-1.14 2.97zm5.36 4.5a8.62 8.62 0 0 1-2.59 1.62 2.07 2.07 0 0 1-1.62.06c-.73-.43-1-2-.62-4.23.05-.25.1-.51.17-.76a23.3 23.3 0 0 0 3.11.45 26 26 0 0 0 2 2.45l-.44.41zm1.12-1.12a20.16 20.16 0 0 1-1.39-1.67h2.75a18 18 0 0 1-1.36 1.67zm6 1.38a2.1 2.1 0 0 1-.76 1.44c-.73.42-2.29-.13-4-1.57l-.58-.53a22.69 22.69 0 0 0 1.93-2.46 22.28 22.28 0 0 0 3.14-.49l.12.56a8.45 8.45 0 0 1 .12 3.05zm.83-4.94l-.38.12a23.85 23.85 0 0 0-1.17-2.93 24.72 24.72 0 0 0 1.13-2.89l.68.22c2.14.73 3.65 1.83 3.65 2.66s-1.61 2.06-3.9 2.82zM12 14.19a2.1 2.1 0 1 0-2.11-2.1 2.1 2.1 0 0 0 2.11 2.1z"
    }
  }],
  title: "sdk-react"
}, {
  name: "svg",
  attrs: {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      "class": "cls-1",
      d: "M18.48 7l-.67-.21c0-.15.07-.31.11-.46.5-2.46.17-4.44-1-5.09s-2.85 0-4.65 1.59c-.17.15-.35.31-.51.47l-.3-.3C9.58 1.29 7.7.58 6.57 1.24s-1.41 2.49-1 4.82q.06.35.15.69c-.26.07-.52.15-.77.24-2.2.76-3.78 2-3.78 3.22s1.68 2.58 4 3.36l.56.18c-.06.25-.11.49-.16.74-.43 2.29-.1 4.11 1 4.73s3 0 4.81-1.61l.43-.4c.18.18.37.34.56.51 1.77 1.52 3.52 2.13 4.6 1.51s1.47-2.6 1-5c0-.19-.08-.37-.12-.56l.39-.12c2.38-.79 4.1-2.06 4.1-3.37S20.73 7.74 18.48 7zM12.9 3.47c1.53-1.34 3-1.87 3.62-1.49s1 2 .53 4.14c0 .14-.06.28-.1.42a20.1 20.1 0 0 0-2.78-.44 19.39 19.39 0 0 0-1.76-2.19c.16-.16.32-.3.49-.44zm-4.78 8.88c.21.36.43.72.65 1.07-.64-.07-1.28-.18-1.91-.31.18-.6.41-1.21.67-1.84.19.36.38.72.59 1.08zm-1.25-5c.59-.13 1.23-.24 1.88-.32q-.33.51-.63 1c-.21.35-.4.71-.59 1.07a18 18 0 0 1-.66-1.8zM8 10.23c.27-.57.57-1.13.88-1.68s.66-1.08 1-1.6c.62 0 1.25-.07 1.9-.07s1.28 0 1.89.07c.35.52.69 1 1 1.59s.62 1.11.9 1.67c-.28.57-.57 1.13-.89 1.68S14 13 13.69 13.5c-.62.05-1.26.07-1.9.07s-1.28 0-1.89-.06c-.36-.52-.69-1.06-1-1.61s-.62-1.1-.9-1.67zm7.46 2.11c.21-.36.4-.73.6-1.1.26.6.49 1.2.7 1.83-.64.14-1.29.25-1.94.33.22-.35.43-.7.64-1.06zm.59-3.16q-.29-.54-.6-1.08c-.2-.35-.41-.7-.63-1a17.87 17.87 0 0 1 1.9.33 18.27 18.27 0 0 1-.67 1.75zm-4.26-4.64A15.82 15.82 0 0 1 13 6h-2.44a18.93 18.93 0 0 1 1.23-1.46zM7 2c.69-.41 2.23.17 3.85 1.61l.32.29A20.76 20.76 0 0 0 9.4 6.1a21.83 21.83 0 0 0-2.77.43c0-.21-.1-.43-.14-.64-.39-2-.14-3.51.51-3.89zM6 12.89l-.51-.16a8.55 8.55 0 0 1-2.6-1.29 1.8 1.8 0 0 1-.77-1.23c0-.76 1.3-1.72 3.18-2.38L6 7.6a22 22 0 0 0 1 2.63 22.51 22.51 0 0 0-1 2.66zm4.82 4.05a7.61 7.61 0 0 1-2.33 1.45 1.85 1.85 0 0 1-1.49.06c-.65-.38-.93-1.84-.56-3.8 0-.23.1-.46.16-.69a20.3 20.3 0 0 0 2.8.4 22.34 22.34 0 0 0 1.78 2.21l-.39.37zm1-1a19.46 19.46 0 0 1-1.25-1.5h2.47c-.38.56-.79 1.01-1.22 1.49zm5.39 1.24a1.8 1.8 0 0 1-.68 1.29c-.65.38-2.05-.11-3.56-1.41l-.53-.47a19.54 19.54 0 0 0 1.74-2.22 19.21 19.21 0 0 0 2.82-.44c0 .17.08.34.11.5a7.42 7.42 0 0 1 .1 2.74zm.79-4.45l-.36.11a19.22 19.22 0 0 0-1.05-2.63 20.55 20.55 0 0 0 1-2.6l.62.19c1.93.66 3.28 1.65 3.28 2.4S20 12.05 18 12.73zm-6.18-.62a1.89 1.89 0 1 0-1.92-1.89 1.89 1.89 0 0 0 1.89 1.89zm-9.54 9.72a.9.9 0 0 0 .61-.9.94.94 0 0 0-1-1H.6v3.16h.49v-1.18h.69l.64 1.21H3zm-.49-.34h-.7v-1.1h.69a.54.54 0 0 1 .61.55.53.53 0 0 1-.6.55zm3.39.56v-.16c0-.75-.4-1.21-1.07-1.21A1.11 1.11 0 0 0 3 21.93a1.09 1.09 0 0 0 1.11 1.23 1 1 0 0 0 1-.69H4.7a.58.58 0 0 1-.57.29.63.63 0 0 1-.64-.68zm-1.07-1a.57.57 0 0 1 .59.61H3.49a.61.61 0 0 1 .62-.57zm2.23-.41c-.54 0-.93.27-1 .68h.46c0-.17.23-.27.5-.27s.48.15.48.4v.2h-.64c-.57 0-.89.28-.89.71a.73.73 0 0 0 .8.72.79.79 0 0 0 .71-.38v.34h.45v-1.55c.06-.49-.28-.81-.87-.81zm.46 1.56a.56.56 0 0 1-.61.52c-.26 0-.45-.13-.45-.34s.15-.32.48-.34h.58zm2.37-.73a.54.54 0 0 0-.57-.4c-.39 0-.63.3-.63.81s.24.82.63.82a.52.52 0 0 0 .57-.39h.46a.94.94 0 0 1-1 .81 1.09 1.09 0 0 1-1.12-1.24 1.09 1.09 0 0 1 1.09-1.2 1 1 0 0 1 1 .83zm1.33-1.37v.6h.5v.4h-.5v1.23c0 .24.1.35.34.35H11v.39a1 1 0 0 1-.25 0c-.52 0-.73-.18-.73-.64v-1.29h-.37v-.4H10v-.6zm1.68 3V20h.44l1.62 2.24V20h.47v3.16h-.44l-1.62-2.25v2.25zm3.91-2.44c-.54 0-.93.27-1 .68h.46c0-.17.23-.27.5-.27s.48.15.48.4v.2h-.64c-.57 0-.89.28-.89.71a.73.73 0 0 0 .8.72.79.79 0 0 0 .71-.38v.34H17v-1.57c0-.49-.31-.81-.91-.81zm.46 1.56a.56.56 0 0 1-.61.52c-.26 0-.45-.13-.45-.34s.15-.32.48-.34h.58zM18 20.14v.6h.52v.4H18v1.23c0 .24.11.35.34.35h.18v.39a1 1 0 0 1-.26 0c-.52 0-.73-.18-.73-.64v-1.33h-.38v-.4h.38v-.6zm.68-.11a.31.31 0 1 1 .3.28.29.29 0 0 1-.31-.31zm.07.7h.47v2.39h-.47zm2 2.39h-.5l-.86-2.39h.5l.59 1.88.59-1.88h.5zm3-1.07v-.16a1.06 1.06 0 0 0-1.07-1.21 1.11 1.11 0 0 0-1.1 1.25 1.08 1.08 0 0 0 1.1 1.23 1 1 0 0 0 1-.69h-.46a.55.55 0 0 1-.56.29.63.63 0 0 1-.64-.68zm-1.07-1a.58.58 0 0 1 .59.61H22a.61.61 0 0 1 .61-.57z"
    }
  }],
  title: "sdk-react-native"
}, {
  name: "svg",
  attrs: {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      "class": "cls-1",
      d: "M2.7 11.27l2.15-3.69a.39.39 0 0 1 .08-.1l3.86-3.59a.42.42 0 0 1 .14-.09l3.32-1.22 2.79 2L13.65 9l-5.22 4.81-4.26.95zm1.78 4.3l2 5.68 1.62-6.49zm15-12.92L16.29 4.4l5.22 3.79a11.27 11.27 0 0 0 .26-1.72 4.37 4.37 0 0 0-.55-2.38 3.49 3.49 0 0 0-1.76-1.43s-.01-.02-.02-.01zM16 16.55L13.83 10l-4.38 4zm-1.39-6.93l2.15 6.55a20.37 20.37 0 0 0 4.37-6.7zm6.06-1l-4.9-3.56-1.17 3.71zM3.82 16.28l-1.45 2.5a3.57 3.57 0 0 0 3.36 2.95zm-.37-1.05l-1.22-2.9v5zm14.9-12.95h-5.06l2.25 1.57zM9 14.75l-1.77 6.92a15.94 15.94 0 0 0 8.36-4.36zm11.34 6.08a.38.38 0 0 1-.28-.11l-3.54-3.12A20.3 20.3 0 0 1 11 21.47l9.37-.63a.37.37 0 0 0 .15 0 .41.41 0 0 1-.21-.01zM17.13 17l3.47 3.08a.37.37 0 0 1 .12.24l.72-9.32a23.06 23.06 0 0 1-4.31 6z"
    }
  }],
  title: "sdk-ruby"
}, {
  name: "svg",
  attrs: {
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      "class": "cls-1",
      d: "M22.94 7.09v-.66A10 10 0 0 0 22.8 5a4.69 4.69 0 0 0-.45-1.37 4.64 4.64 0 0 0-2-2 4.88 4.88 0 0 0-1.35-.5A8.75 8.75 0 0 0 17.51 1H6a7.89 7.89 0 0 0-1.09.11 6.47 6.47 0 0 0-1 .3l-.33.16a4.22 4.22 0 0 0-.91.6 3.07 3.07 0 0 0-.26.25 4.71 4.71 0 0 0-.86 1.17A5 5 0 0 0 1.07 5 8.78 8.78 0 0 0 1 6.43v11.14A10 10 0 0 0 1.07 19a5.21 5.21 0 0 0 .46 1.38 4.64 4.64 0 0 0 2 2 4.69 4.69 0 0 0 1.37.45 10 10 0 0 0 1.47.17h11.14a10 10 0 0 0 1.49-.14 4.85 4.85 0 0 0 1.38-.45 4.69 4.69 0 0 0 2-2A4.85 4.85 0 0 0 22.8 19a10 10 0 0 0 .13-1.44V7.09zM19.5 18.93c-1-1.92-2.81-1.44-3.74-1l-.26.15a8.29 8.29 0 0 1-7.16 0 11.4 11.4 0 0 1-5.17-4.44 11 11 0 0 0 1.92 1.15 8 8 0 0 0 7.51 0 41.6 41.6 0 0 1-6.95-7.2 9.55 9.55 0 0 1-.92-1.27 51.85 51.85 0 0 0 6.75 5.11 48.34 48.34 0 0 1-4.75-6 47.79 47.79 0 0 0 7.82 6.42 3.78 3.78 0 0 1 .33.19 6.26 6.26 0 0 0 .21-.61 8.79 8.79 0 0 0-1.74-7.33c3.77 2.27 6 6.57 5.09 10.21 0 .08-.05.16-.07.25 1.89 2.32 1.37 4.82 1.13 4.35z"
    }
  }],
  title: "sdk-swift"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M9.065 18.125C4.066 18.125 0 14.06 0 9.062S4.066 0 9.065 0c4.995 0 9.059 4.065 9.059 9.062s-4.064 9.063-9.059 9.063zM9.065 1C4.618 1 1 4.617 1 9.062s3.618 8.062 8.065 8.062c4.443 0 8.059-3.617 8.059-8.062S13.508 1 9.065 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M23 23.5a.502.502 0 0 1-.354-.146l-7.875-7.875a.5.5 0 0 1 .707-.707l7.875 7.875A.5.5 0 0 1 23 23.5z"
    }
  }],
  title: "search"
}, {
  name: "svg",
  attrs: {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M10 12c-5.3 0-9-1.8-9-3.5v-2C2.6 8 6 9 10 9s7.4-1 9-2.5V9c0 .3.2.5.5.5s.5-.2.5-.5V4.5C20 2 15.6 0 10 0S0 2 0 4.5v13c0 2.4 3.8 4.3 9 4.5.3 0 .5-.2.5-.5S9.3 21 9 21c-4.4-.2-8-1.8-8-3.5V15c1.4 1.3 4.1 2.2 7.5 2.4.3 0 .5-.2.5-.5s-.2-.5-.5-.5C4 16.1 1 14.4 1 13v-2.5C2.6 12 6 13 10 13c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm0-11c5.3 0 9 1.8 9 3.5S15.3 8 10 8 1 6.2 1 4.5 4.7 1 10 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M22 15v-.5c0-2-1.5-3.5-3.5-3.5S15 12.5 15 14.5v.5h-2v9h11v-9h-2zm-6-.5c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v.5h-5v-.5zm7 8.5h-9v-7h9v7z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M18.5 17.5c-.6 0-1 .4-1 1 0 .4.2.7.5.9V21c0 .3.2.5.5.5s.5-.2.5-.5v-1.6c.3-.2.5-.5.5-.9 0-.6-.4-1-1-1z"
    }
  }],
  title: "secure-environment"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M13.5 24h-3a.5.5 0 0 1-.5-.5v-2.854c-.791-.2-1.669-.456-2.332-.78L5.636 21.9a.514.514 0 0 1-.707 0L2.1 19.071a.5.5 0 0 1 0-.708l2.033-2.033c-.322-.661-.578-1.539-.779-2.33H.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h2.854c.201-.791.456-1.668.778-2.331L2.1 5.636a.5.5 0 0 1 0-.707l2.829-2.828a.5.5 0 0 1 .707 0l2.033 2.032c.665-.324 1.542-.579 2.331-.778V.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v2.855c.789.198 1.664.452 2.33.777L18.363 2.1a.5.5 0 0 1 .707 0l2.829 2.828a.5.5 0 0 1 0 .708l-2.032 2.032c.324.665.578 1.542.778 2.332H23.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-2.854c-.201.791-.456 1.669-.778 2.331l2.032 2.033a.5.5 0 0 1 0 .707l-2.828 2.828a.5.5 0 0 1-.707 0l-2.034-2.032c-.662.322-1.54.578-2.33.778V23.5a.502.502 0 0 1-.501.5zM11 23h2v-2.746a.5.5 0 0 1 .382-.486c.558-.135 2.04-.493 2.777-.944a.5.5 0 0 1 .614.073l1.944 1.942 2.121-2.121-1.942-1.943a.5.5 0 0 1-.073-.614c.45-.736.81-2.22.945-2.777a.5.5 0 0 1 .486-.384H23v-2h-2.747a.5.5 0 0 1-.486-.383c-.134-.557-.491-2.036-.944-2.778a.5.5 0 0 1 .073-.614l1.942-1.942-2.122-2.121-1.943 1.942a.503.503 0 0 1-.614.073c-.668-.408-1.904-.733-2.776-.942A.502.502 0 0 1 13 3.748V1h-2v2.748a.5.5 0 0 1-.383.486c-.873.209-2.11.535-2.777.943a.502.502 0 0 1-.614-.073L5.282 3.161 3.16 5.282l1.943 1.943a.501.501 0 0 1 .074.615c-.451.737-.81 2.22-.945 2.777a.5.5 0 0 1-.486.383H1v2h2.746a.5.5 0 0 1 .486.383c.135.558.495 2.041.945 2.777a.5.5 0 0 1-.073.614L3.16 18.718l2.122 2.121 1.942-1.944a.5.5 0 0 1 .615-.073c.738.453 2.22.812 2.778.946a.5.5 0 0 1 .383.486V23z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M12 17c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zm0-9c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z"
    }
  }],
  title: "settings"
}, {
  name: "svg",
  attrs: {
    viewBox: "0 0 1792 1792",
    xmlns: "http://www.w3.org/2000/svg"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M576 1376v-192q0-14-9-23t-23-9H224q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384V800q0-14-9-23t-23-9H224q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9H736q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM576 608V416q0-14-9-23t-23-9H224q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384V800q0-14-9-23t-23-9H736q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768V416q0-14-9-23t-23-9H736q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384V800q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384V416q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm128-320v1088q0 66-47 113t-113 47H224q-66 0-113-47t-47-113V288q0-66 47-113t113-47h1344q66 0 113 47t47 113z"
    }
  }],
  title: "spreadsheet"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M18.84 22.5a.5.5 0 0 1-.231-.057l-6.583-3.439-6.581 3.439a.502.502 0 0 1-.724-.528l1.256-7.281L.652 9.476a.501.501 0 0 1 .277-.855l7.36-1.062L11.578.932c.169-.34.727-.34.896 0l3.292 6.627 7.358 1.062a.5.5 0 0 1 .276.855l-5.322 5.157 1.256 7.282a.501.501 0 0 1-.494.585zm-6.815-4.561c.08 0 .159.019.231.057l5.918 3.093-1.129-6.546a.5.5 0 0 1 .146-.444l4.781-4.633-6.61-.955a.501.501 0 0 1-.377-.272l-2.96-5.96-2.958 5.96a.5.5 0 0 1-.376.272l-6.612.955 4.783 4.633a.5.5 0 0 1 .145.444l-1.129 6.546 5.916-3.093a.493.493 0 0 1 .231-.057z"
    }
  }],
  title: "star"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M12.406 20.971a9.452 9.452 0 0 0 6.627-2.686.5.5 0 0 0-.695-.719 8.5 8.5 0 0 1-6.255 2.398 8.637 8.637 0 0 1-6.236-3.014c-1.337-1.564-2.042-3.547-2.037-5.673l2.501 2.858a.5.5 0 1 0 .752-.658L3.731 9.671a.49.49 0 0 0-.408-.17.503.503 0 0 0-.384.222L.084 14.006a.5.5 0 1 0 .832.554l1.901-2.852c.085 2.201.866 4.249 2.269 5.892a9.64 9.64 0 0 0 7.32 3.371zm8.239-7.465l.032-.001a.5.5 0 0 0 .384-.222l2.855-4.284a.5.5 0 1 0-.832-.554l-1.901 2.853c-.085-2.201-.865-4.249-2.269-5.892a9.639 9.639 0 0 0-6.96-3.364 9.598 9.598 0 0 0-7.229 2.922.498.498 0 1 0 .72.692 8.532 8.532 0 0 1 6.472-2.615 8.639 8.639 0 0 1 6.237 3.014c1.336 1.564 2.041 3.547 2.036 5.673L17.689 8.87a.499.499 0 1 0-.752.658l3.331 3.808c.095.108.233.17.377.17z"
    }
  }],
  title: "sync"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M18.5 24h-13A2.503 2.503 0 0 1 3 21.5v-19C3 1.121 4.122 0 5.5 0h13C19.879 0 21 1.121 21 2.5v19c0 1.379-1.121 2.5-2.5 2.5zM5.5 1C4.673 1 4 1.673 4 2.5v19c0 .827.673 1.5 1.5 1.5h13c.827 0 1.5-.673 1.5-1.5v-19c0-.827-.673-1.5-1.5-1.5h-13z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M18.5 20h-13a.5.5 0 0 1-.5-.5v-16a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v16a.5.5 0 0 1-.5.5zM6 19h12V4H6v15zm6-17.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M9.5 8h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm3 0h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm3 0h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm-6 3h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm3 0h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm3 0h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm-6 3h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm3 0h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5z"
    }
  }, {
    name: "circle",
    attrs: {
      cx: "12",
      cy: "21.5",
      r: "1"
    }
  }],
  title: "tablet"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M14.5 24a.502.502 0 0 1-.354-.146l-14-14A.504.504 0 0 1 0 9.5v-7A.5.5 0 0 1 .5 2h7c.133 0 .26.053.354.146l14 14a.5.5 0 0 1 0 .707l-7 7A.5.5 0 0 1 14.5 24zM1 9.293l13.5 13.5 6.293-6.293L7.293 3H1v6.293z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M22.25 15a.5.5 0 0 1-.313-.891l.813-.65L10.293 1H3a.5.5 0 0 1 0-1h7.5c.133 0 .26.053.354.146l13 13a.502.502 0 0 1-.041.744l-1.25 1a.502.502 0 0 1-.313.11zM5 9c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
    }
  }],
  title: "tags"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M6 14c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7L7.8 11 5.6 8.9c-.2-.2-.2-.5 0-.7s.5-.2.7 0l2.5 2.5c.2.2.2.5 0 .7l-2.5 2.5c0 .1-.2.1-.3.1zm9-2h-4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4c.3 0 .5.2.5.5s-.2.5-.5.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M23.5 22H.5c-.3 0-.5-.2-.5-.5v-19c0-.3.2-.5.5-.5h23c.3 0 .5.2.5.5v19c0 .3-.2.5-.5.5zM1 21h22V3H1v18z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M21.5 20h-19c-.3 0-.5-.2-.5-.5v-15c0-.3.2-.5.5-.5h19c.3 0 .5.2.5.5v15c0 .3-.2.5-.5.5zM3 19h18V5H3v14z"
    }
  }],
  title: "toolbar-code-editor"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M10 13H2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h8c.3 0 .5.2.5.5s-.2.5-.5.5zm11 0h-8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h8c.3 0 .5.2.5.5s-.2.5-.5.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M21.5 21h-20c-.3 0-.5-.2-.5-.5v-13c0-.3.2-.5.5-.5h20c.3 0 .5.2.5.5v13c0 .3-.2.5-.5.5zM2 20h19V8H2v12z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M12.5 16h-2c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h2c.3 0 .5.2.5.5v4c0 .3-.2.5-.5.5zM11 15h1v-3h-1v3zm4.7-7h-1c0-2-1.4-3.2-3.2-3.2S8.3 6 8.3 8h-1c0-3 1.9-4.2 4.2-4.2 2.3 0 4.2 1.2 4.2 4.2z"
    }
  }],
  title: "toolbar-dev-tools"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M17.4 23h-7.1c-.2 0-.3-.05-.4-.15l-3.6-5.875c-.4-.5-.5-1.488-.2-2.188.2-.4.55-.594.95-.594.9.001 1.95.207 2.95 1.907V7.9c0-1.1 1.1-1.8 2-1.8 1.1 0 2 .9 2 1.8v5l3.65 1.2c1.2.4 1.425 2.2 1.225 3.2l-.888 5.25c-.2.3-.387.45-.587.45zm-6.9-1H17l.9-4.85c.2-.8 0-1.875-.5-2.075l-4-1.288c-.2-.099-.4-.287-.4-.487V7.9c0-.4-.5-.8-1-.8s-1 .4-1 .8v9.8c0 .2 0 .4-.2.5-.2.1-.35 0-.55-.2-2-2.7-2.375-2.7-3.075-2.7-.1 0-.087 0-.087.1-.1.2-.094.75.206 1.15L10.5 22z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M17.8 12H17v-1h.8c1.1 0 2.2-.5 2.2-1.7V3.9C20 2.6 18.9 2 17.8 2H6.2C5.2 2 4 2.6 4 3.9v5.3C4 10.5 5.1 11 6.2 11H8v1H6.2C4.3 12 3 10.8 3 9.2V3.9C3 2.2 4.3 1 6.2 1h11.6C19.7 1 21 2.3 21 3.9v5.3c.1 1.7-1.3 2.8-3.2 2.8z"
    }
  }],
  title: "toolbar-interactive-mode"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M16 20H2.2c-1 0-1.2-.7-1.2-1V5.2C1 4.5 1.5 4 2.2 4H19c.5 0 1 .3 1 1.2V8c0 .3-.2.5-.5.5S19 8.3 19 8V5H2.2c-.1 0-.2.1-.2.2V19h14c.3 0 .5.2.5.5s-.2.5-.5.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M19 8H2c-.3 0-.5-.2-.5-.5S1.7 7 2 7h17c.3 0 .5.2.5.5s-.2.5-.5.5zm3.5 10h-7.3c-.2 0-.4-.1-.5-.3-.1-.2 0-.4.1-.5l1.9-2c-2.3-1.1-4.5-1.3-5.7-.5-.8.5-1.2 1.3-1.2 2.6 0 .3-.2.5-.5.5s-.5-.2-.5-.5c0-2.6.8-4.6 2.5-5.8 2.1-1.6 5.4-1.8 9.3-.6L22.1 9c.1-.2.4-.2.6-.1.2.1.3.2.3.5v8.1c0 .3-.2.5-.5.5zm-6.1-1H22v-6.3l-.8 1c-.1.1-.3.2-.5.2-3.7-1.1-6.8-1-8.7.4-.6.4-1 .9-1.3 1.5 2-1.1 5-.3 7.2.8.1.1.2.2.3.4 0 .2 0 .3-.1.4L16.4 17z"
    }
  }],
  title: "toolbar-new-window"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M16 20H2.2c-1 0-1.2-.7-1.2-1V5.2C1 4.5 1.5 4 2.2 4H19c.5 0 1 .3 1 1.2V8c0 .3-.2.5-.5.5S19 8.3 19 8V5H2.2c-.1 0-.2.1-.2.2V19h14c.3 0 .5.2.5.5s-.2.5-.5.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M19 8H2c-.3 0-.5-.2-.5-.5S1.7 7 2 7h17c.3 0 .5.2.5.5s-.2.5-.5.5zM8.8 17.5V9.4c0-.3.1-.4.3-.5.2-.1.5-.1.6.1l1.5 1.9c3.9-1.2 7.2-1 9.3.6 1.7 1.2 2.5 3.2 2.5 5.8 0 .3-.2.5-.5.5s-.5-.2-.5-.5c0-1.3-.4-2.1-1.2-2.6-1.2-.8-3.4-.6-5.7.5l1.9 2c.1.1.2.3.1.5s-.3.3-.5.3H9.3c-.3 0-.5-.2-.5-.5zm4.9-2.1c-.1-.1-.1-.2-.1-.4.1-.2.2-.3.3-.4 2.2-1.1 5.2-1.9 7.2-.8-.3-.6-.7-1.1-1.3-1.5-1.9-1.4-5-1.5-8.7-.4-.2 0-.4-.1-.5-.2l-.8-1V17h5.6l-1.7-1.6z"
    }
  }],
  title: "toolbar-new-window-close"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M10.768 21.6c3.2 0 6.2-1.6 8-4.3.1-.3 0-.6-.2-.7-.2-.2-.5-.1-.7.1-1.7 2.5-4.4 4-7.5 3.9-4.7-.2-8.4-4.1-8.2-8.8.2-4.7 4.2-8.4 8.8-8.2 2.4.1 4.7 1.2 6.2 3 1.3 1.6 2 3.5 2 5.7l-2.5-2.9c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l3.3 3.8c.2 0 .4.1.5.1.2 0 .3-.1.4-.2l2.9-4.3c.1-.3 0-.6-.2-.7-.2-.2-.5-.1-.7.1l-1.9 2.8c-.1-2.2-.9-4.2-2.3-5.9-1.7-2-4.3-3.3-7-3.4-5.2-.2-9.7 3.9-9.9 9.2s3.9 9.7 9.2 9.9c.2.1.3.1.5.1z"
    }
  }],
  title: "toolbar-reload"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M20.2 19H3.8c-1 0-1.8-.8-1.8-1.8V4.8C2 3.8 2.8 3 3.8 3h16.4c1 0 1.8.8 1.8 1.8v12.4c0 1-.8 1.8-1.8 1.8zM3.8 4c-.4 0-.8.4-.8.8v12.4c0 .4.4.8.8.8h16.4c.4 0 .8-.4.8-.8V4.8c0-.4-.4-.8-.8-.8H3.8zM6 21h11v1H6z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M15 22H9c-.2 0-.3-.1-.4-.2-.1-.1-.1-.3-.1-.4l.9-3c0-.3.2-.4.5-.4h4.3c.2 0 .4.1.5.4l.9 3c0 .2 0 .3-.1.4-.2.1-.3.2-.5.2zm-5.3-1h4.7l-.6-2h-3.5l-.6 2zm9.8-5h-15c-.3 0-.5-.2-.5-.5v-10c0-.3.2-.5.5-.5h15c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5zM5 15h14V6H5v9z"
    }
  }, {
    name: "circle",
    attrs: {
      cx: "12",
      cy: "16.7",
      r: ".9"
    }
  }],
  title: "toolbar-size-desktop"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M17.2 14.2l-.7-.7 2-2-2-2 .7-.7 2.3 2.3c.2.2.2.5 0 .7l-2.3 2.4z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M5 11h14v1H5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M6.8 14.2l-2.3-2.3c-.2-.2-.2-.5 0-.7l2.3-2.3.7.7-2 2 2 2-.7.6zM2 6h1v11H2zm19 0h1v11h-1z"
    }
  }],
  title: "toolbar-size-full-width"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M15.9 21H8.1C6.9 21 6 20.1 6 18.9V4.1C6 2.9 6.9 2 8.1 2H16c1.1 0 2 .9 2 2.1V19c0 1.1-.9 2-2.1 2zM8.1 3C7.5 3 7 3.5 7 4.1V19c0 .5.5 1 1.1 1H16c.6 0 1.1-.5 1.1-1.1V4.1C17 3.5 16.5 3 15.9 3H8.1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M6 6h11v1H6zm0 11h11v1H6zm4-13h4v1h-4z"
    }
  }, {
    name: "circle",
    attrs: {
      cx: "12",
      cy: "19.4",
      r: ".9"
    }
  }],
  title: "toolbar-size-mobile"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M18.5 24h-13A2.503 2.503 0 0 1 3 21.5v-19C3 1.121 4.122 0 5.5 0h13C19.879 0 21 1.121 21 2.5v19c0 1.379-1.121 2.5-2.5 2.5zM5.5 1C4.673 1 4 1.673 4 2.5v19c0 .827.673 1.5 1.5 1.5h13c.827 0 1.5-.673 1.5-1.5v-19c0-.827-.673-1.5-1.5-1.5h-13z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M18.5 20h-13a.5.5 0 0 1-.5-.5v-16a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v16a.5.5 0 0 1-.5.5zM6 19h12V4H6v15zm6-17.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M9.5 8h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm3 0h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm3 0h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm-6 3h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm3 0h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm3 0h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm-6 3h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5zm3 0h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5z"
    }
  }, {
    name: "circle",
    attrs: {
      cx: "12",
      cy: "21.5",
      r: "1"
    }
  }],
  title: "toolbar-size-tablet"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M20.8 19H4.2c-.9 0-2.2-.7-2.2-1.8V6c0-1 1.3-2 2.2-2h16.6c1 0 2.2 1 2.2 2v11.2c0 1.1-1.3 1.8-2.2 1.8zM4.2 5C3.8 5 3 5.6 3 6v11.2c0 .4.7.8 1.2.8h16.6c.5 0 1.2-.4 1.2-.8V6c0-.4-.7-1-1.2-1H4.2zM8 20h9v1H8zm4-1h1v1h-1z"
    }
  }, {
    name: "circle",
    attrs: {
      cx: "12.6",
      cy: "16.4",
      r: ".9"
    }
  }, {
    name: "path",
    attrs: {
      d: "M3 14h19v1H3z"
    }
  }],
  title: "toolbar-size-widescreen"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M18.968 24H6.032a.501.501 0 0 1-.5-.481l-.746-20a.499.499 0 0 1 .5-.519h14.428a.502.502 0 0 1 .5.518l-.746 20a.502.502 0 0 1-.5.482zM6.514 23h11.973l.709-19H5.805l.709 19z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M15.5 4h-6a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5zM10 3h5V1h-5v2z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M22 4H3a.5.5 0 0 1 0-1h19a.5.5 0 0 1 0 1zM9.5 19.5A.5.5 0 0 1 9 19V8a.5.5 0 0 1 1 0v11a.5.5 0 0 1-.5.5zm3 0a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 1 0v11a.5.5 0 0 1-.5.5zm3 0a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 1 0v11a.5.5 0 0 1-.5.5z"
    }
  }],
  title: "trash"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M17.095 22H14a.5.5 0 0 1 0-1h3.095C20.186 21 23 17.902 23 14.5S20.186 8 17.095 8H1a.5.5 0 0 1 0-1h16.095C20.773 7 24 10.505 24 14.5S20.773 22 17.095 22z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M5.427 12.854a.502.502 0 0 1-.354-.146L.146 7.78a.5.5 0 0 1 .043-.744l4.927-3.927a.498.498 0 0 1 .702.079.498.498 0 0 1-.079.702l-4.49 3.579 4.531 4.532a.5.5 0 0 1-.353.853z"
    }
  }],
  title: "undo"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M12.5 23.5a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 1 0v16a.5.5 0 0 1-.5.5z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M17 12.718a.5.5 0 0 1-.391-.188L12.5 7.394 8.391 12.53a.501.501 0 0 1-.781-.625l4.5-5.625a.52.52 0 0 1 .781 0l4.5 5.625a.5.5 0 0 1-.391.813z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M20.5 18H17a.5.5 0 0 1 0-1h3V1H4v16h4a.5.5 0 0 1 0 1H3.5a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 .5.5v17a.5.5 0 0 1-.5.5z"
    }
  }],
  title: "upload"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M1.629 21.124a.506.506 0 0 1-.192-.038c-.777-.323-.318-2.425-.312-2.445.11-.397.511-.541 1.884-.979.614-.196 1.641-.524 1.829-.699.233-.24.377-1.084.401-1.579.013-.275.263-.504.523-.475a.5.5 0 0 1 .476.523c-.013.268-.106 1.632-.684 2.228-.311.322-1.054.575-2.241.954-.435.14-1.009.322-1.252.437a6.884 6.884 0 0 0-.06 1.073l10.984-.021a6.027 6.027 0 0 0-.019-1.036c-.249-.11-.839-.295-1.286-.435-1.289-.403-2.094-.672-2.405-.998-.577-.605-.485-1.933-.461-2.192a.51.51 0 0 1 .544-.452.5.5 0 0 1 .452.544c-.047.523.019 1.231.19 1.411.197.176 1.312.524 1.979.732 1.327.415 1.654.537 1.829.789.221.318.324 2.072-.074 2.483a.499.499 0 0 1-.358.152l-11.747.023c.001 0 .001 0 0 0z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M7.416 16.396c-1.418 0-2.82-1.341-3.75-3.587-.277-.67-.442-2.14-.442-3.933C3.223 6.188 5.104 4 7.416 4c2.351 0 4.192 2.108 4.192 4.801 0 1.867-.167 3.364-.445 4.006-.991 2.281-2.356 3.589-3.747 3.589zM7.416 5c-1.76 0-3.192 1.739-3.192 3.877 0 1.841.184 3.109.366 3.55.907 2.189 2.055 2.97 2.827 2.97.741 0 1.874-.785 2.83-2.988.18-.415.362-1.691.362-3.607C10.607 6.67 9.206 5 7.416 5zM23 5h-8a.5.5 0 0 1 0-1h8a.5.5 0 0 1 0 1zm0 3h-8a.5.5 0 0 1 0-1h8a.5.5 0 0 1 0 1zm0 3h-8a.5.5 0 0 1 0-1h8a.5.5 0 0 1 0 1zm0 3h-6a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1z"
    }
  }],
  title: "userlist"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M22.5 23h-21C.529 23 0 21.627 0 20.921V1.546C0 .693.673 0 1.5 0h21c.827 0 1.5.693 1.5 1.546v19.375c0 .706-.529 2.079-1.5 2.079zM1.5 1c-.276 0-.5.245-.5.546v19.375c0 .433.339 1.079.506 1.079H22.5c.161 0 .5-.646.5-1.079V1.546c0-.301-.224-.546-.5-.546h-21z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M20 8h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1zm-8 0H4a.5.5 0 0 1 0-1h8a.5.5 0 0 1 0 1zm8 8h-8a.5.5 0 0 1 0-1h8a.5.5 0 0 1 0 1zM7 16H4a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M15.5 10.5c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm-6 13c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z"
    }
  }],
  title: "variation-settings"
}, {
  name: "svg",
  attrs: {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M480 272H320c-17.625 0-32 14.375-32 32v160c0 17.625 14.375 32 32 32h160c17.625 0 32-14.375 32-32V304c0-17.625-14.375-32-32-32zm0 192H320V304h160v160zM193.01 224h189.986c25.332 0 41.221-26.688 28.555-48.016L316.557 15.969C310.557 6.125 299.67 0 288.004 0s-22.555 6.125-28.555 15.969l-94.994 160.015C151.789 197.312 167.678 224 193.01 224zm93.763-191.377c.184-.299.706-.623 1.231-.623l1.037.303L382.996 192l-191.023.318 94.8-159.695zM128 256C57.25 256 0 313.25 0 384s57.25 128 128 128 128-57.25 128-128-57.25-128-128-128zm0 224c-52.934 0-96-43.066-96-96 0-52.936 43.066-96 96-96 52.936 0 96 43.064 96 96 0 52.934-43.064 96-96 96z"
    }
  }],
  title: "variations"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M7.725 18.867a.502.502 0 0 1-.353-.146L.647 12.033a.5.5 0 0 1-.002-.707l6.688-6.725a.5.5 0 0 1 .709.707l-6.335 6.37 6.37 6.335a.5.5 0 0 1-.352.854zm8.55 0a.5.5 0 0 1-.352-.854l6.37-6.335-6.335-6.37a.5.5 0 1 1 .709-.705l6.688 6.725a.5.5 0 0 1-.002.707l-6.725 6.688a.506.506 0 0 1-.353.144z"
    }
  }],
  title: "view-code"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M11.594 22.5c-.574 0-1.131-.24-1.528-.659-.317-.334-.695-.961-.695-2.005 0-1.419.546-3.836.833-4.836H2.977C1.905 15 1 14.15 1 13.133c0-.792.548-1.483 1.296-1.754a1.774 1.774 0 0 1-.312-.994c0-.792.548-1.487 1.296-1.758a1.78 1.78 0 0 1-.31-.995c0-.792.548-1.488 1.296-1.758a1.782 1.782 0 0 1-.311-.996C3.955 3.86 4.86 3 5.932 3h6.402c1.728 0 2.601.35 3.526.72 1.242.498 2.955 1.117 7.474 1.117.276 0 .667.224.667.5v8.265c-.001.276-.558.398-.834.398h-2.955c-3.257 0-6.886 2.862-6.886 6.897 0 .885-.745 1.603-1.732 1.603zM2.977 12C2.466 12 2 12.541 2 13c0 .459.466 1 .977 1h7.879c.157 0 .304.083.398.208a.51.51 0 0 1 .083.442c-.01.034-.966 3.448-.966 5.193 0 .565.146 1.019.42 1.308.287.303.626.348.803.348.294 0 .732-.198.732-.602 0-4.624 4.156-7.897 7.886-7.897H23V5.834c-5-.045-6.072-.675-7.345-1.186C14.75 4.286 13.868 4 12.333 4H5.932c-.512 0-.977.418-.977.878 0 .459.466.877.977.877.276 0 .5.346.5.623S6.208 7 5.932 7h-.985c-.511 0-.977.295-.977.755 0 .459.466.816.977.816.276 0 .5.438.5.714s-.224.715-.5.715h-.985c-.511 0-.977.173-.977.633 0 .459.466.754.977.754.276 0 .5.03.5.306s-.224.307-.5.307h-.985z"
    }
  }],
  title: "vote-down"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M18.735 21h-6.401c-1.728 0-2.602-.35-3.526-.721-1.242-.497-2.788-1.116-7.307-1.116a.5.5 0 0 1-.5-.5v-8.265C1 10.122 1.224 10 1.5 10h2.955c3.257 0 6.886-2.862 6.886-6.897 0-.885.745-1.577 1.732-1.577.574 0 1.131.228 1.528.646.317.334.695.955.695 1.999 0 1.419-.546 3.83-.833 4.83h7.227c1.072 0 1.977.85 1.977 1.867 0 .792-.548 1.483-1.296 1.754.196.291.312.631.312.994 0 .792-.548 1.487-1.296 1.758.196.291.312.633.312.995 0 .792-.548 1.488-1.296 1.758.196.291.312.634.312.996-.003 1.017-.908 1.877-1.98 1.877zM2 18.166c4.331.045 5.905.675 7.179 1.186.904.362 1.619.648 3.154.648h6.401c.511 0 .977-.418.977-.878 0-.459-.466-.877-.977-.877-.276 0-.5-.346-.5-.623s.224-.622.501-.622h.985c.511 0 .977-.295.977-.755 0-.459-.466-.816-.977-.816-.276 0-.5-.438-.5-.714s.223-.715.5-.715h.985c.511 0 .977-.173.977-.633 0-.459-.466-.754-.977-.754-.276 0-.5-.03-.5-.306s.223-.307.5-.307h.985c.511 0 .977-.541.977-1 0-.459-.466-1-.977-1h-7.879a.507.507 0 0 1-.398-.208.507.507 0 0 1-.084-.442c.01-.034.966-3.448.966-5.193 0-.565-.146-1.019-.42-1.308a1.098 1.098 0 0 0-.803-.348c-.294 0-.732.198-.732.602C12.341 7.727 8.185 11 4.455 11H2v7.166z"
    }
  }],
  title: "vote-up"
}, {
  name: "svg",
  attrs: {
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  },
  childs: [{
    name: "path",
    attrs: {
      d: "M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-23C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M4.335 17a.5.5 0 0 1-.369-.838L9.67 9.924a.504.504 0 0 1 .684-.051l3.9 3.159 4.866-5.689a.5.5 0 0 1 .76.65l-5.183 6.06a.5.5 0 0 1-.694.063l-3.913-3.17-5.386 5.892a.502.502 0 0 1-.369.162z"
    }
  }, {
    name: "path",
    attrs: {
      d: "M19.5 13.5a.5.5 0 0 1-.5-.5V8h-4a.5.5 0 0 1 0-1h4.5a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.5.5z"
    }
  }],
  title: "winner"
}];
var HELP_ICON_TITLE = "help";
var propTypes = {
  description: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  fillRule: _propTypes["default"].string,
  name: _propTypes["default"].string.isRequired,
  role: _propTypes["default"].string,
  size: _propTypes["default"].string,
  style: _propTypes["default"].object,
  title: _propTypes["default"].string,
  viewBox: _propTypes["default"].string
};

function findIcon(name) {
  var iconsObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : icons;
  var icon = iconsObj.filter(function (obj) {
    return obj.title.split(" ").join("-") === name;
  });
  if (icon.length > 1) throw new Error("More than one icon was found with same name ".concat(name));
  if (icon.length < 1) throw new Error("No icon found with that name ".concat(name));
  var iconObj = icon.length === 0 ? false : icon[0];
  return iconObj;
}

function buildSvg(iconData) {
  var svgElements = iconData.map(function (prop, index) {
    if (prop.name === "path") {
      return _react["default"].createElement("path", _extends({}, prop.attrs, {
        key: "path-".concat(index)
      }));
    } else if (prop.name === "circle") {
      return _react["default"].createElement("circle", _extends({}, prop.attrs, {
        key: "circle-".concat(index)
      }));
    } else if (prop.name === "polygon") {
      return _react["default"].createElement("polygon", _extends({}, prop.attrs, {
        key: "polygon-".concat(index)
      }));
    } else if (prop.name === "polyline") {
      return _react["default"].createElement("polyline", _extends({}, prop.attrs, {
        key: "polyline-".concat(index)
      }));
    } else if (prop.name === "line") {
      return _react["default"].createElement("line", _extends({}, prop.attrs, {
        key: "line-".concat(index)
      }));
    } else if (prop.name === "rect") {
      return _react["default"].createElement("rect", _extends({}, prop.attrs, {
        key: "rect-".concat(index)
      }));
    } else if (prop.name === "ellipse") {
      return _react["default"].createElement("ellipse", _extends({}, prop.attrs, {
        key: "ellipse-".concat(index)
      }));
    } else if (prop.name === "g") {
      return buildSvg(prop.childs);
    } else {
      return null;
    }
  });
  return svgElements;
}

var Icon = function Icon(_ref) {
  var _ref$description = _ref.description,
      description = _ref$description === void 0 ? "icon" : _ref$description,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? "currentColor" : _ref$fill,
      name = _ref.name,
      role = _ref.role,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? "none" : _ref$stroke,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title;
  var icon = findIcon("".concat(name));
  var sizeNumber;

  if (size === "small") {
    sizeNumber = "12";
  } else if (size === "medium") {
    sizeNumber = "16";
  } else if (size === "large") {
    sizeNumber = "24";
  }

  var iconStyles = Object.assign({}, style, {
    fill: fill,
    stroke: stroke
  });
  var svgClass = "oui-icon display--inline oui-icon--".concat(sizeNumber);
  var props = {
    className: svgClass,
    height: sizeNumber,
    name: "".concat(name),
    role: role,
    stroke: stroke,
    fill: fill,
    style: iconStyles,
    viewBox: icon.attrs.viewBox,
    width: sizeNumber
  };
  var content = icon ? buildSvg(icon.childs) : "";
  return _react["default"].createElement("svg", _extends({
    "data-oui-component": true
  }, props), icon.title !== HELP_ICON_TITLE && _react["default"].createElement("title", null, title || icon.title), _react["default"].createElement("desc", null, description), content);
};

Icon.propTypes = propTypes;

var _default = _react["default"].memo(Icon);

exports["default"] = _default;